/**
 * DO NOT EDIT THIS FILE
 */
import { CartOrderProductOptions } from '../module/yanolja_clientlog_custom_order/cart-order-product-options'
import { CouponOptions } from '../module/yanolja/coupon-options'
import { CartOrderDiscountSelectionType } from '../module/yanolja_clientlog_custom_order/cart-order-discount-selection-type'
import { CartOrderDiscountInfo } from '../module/yanolja_clientlog_custom_order/cart-order-discount-info'
import { CouponSelectionOptions } from '../module/yanolja_clientlog_custom_order/coupon-selection-options'
import { MemberRewardBenefit } from '../module/yanolja_clientlog_custom_member/member-reward-benefit'
import { ProductCategory } from '../module/yanolja_standardcode/product-category'
import { OrderTermsType } from '../module/yanolja_standardcode/order-terms-type'
import { OrderCompleteProductOptions } from '../module/yanolja_clientlog_custom_order/order-complete-product-options'
import { CashReceiptType } from '../module/yanolja_clientlog_custom_order/cash-receipt-type'
import { CashReceiptOption } from '../module/yanolja_clientlog_custom_order/cash-receipt-option'
import { CashReceiptInputEventType } from '../module/yanolja_clientlog_custom_order/cash-receipt-input-event-type'
import { AmlVerifyIdentificationType } from '../module/yanolja_clientlog_custom_order/aml-verify-identification-type'
import { PaymentLogContext } from '../module/yanolja_clientlog_custom_payment/payment-log-context'
import { CartProductOptions } from '../module/yanolja_clientlog_custom_order/cart-product-options'
import { CartClickType } from '../module/yanolja_clientlog_custom_order/cart-click-type'
import { CartPopupType } from '../module/yanolja_clientlog_custom_order/cart-popup-type'
import { KinesisTracker } from '@yanolja-org/ya-tracker'

/**
 * PageName: CART_ORDER    */
export const CartOrderPageLog = {
  FullScreenDialogTitle: {
    /**
        * 주문페이지 -  쿠폰 할인(풀스크린 다이아로그) - 노출
        * https://screen.yanolja.in/tAmZwJHG3rX18vfJ
cusomjson 영역에 이미 정의했는데, 이것을 빼내어 표현해주실 수 있나요?
100% 전환 이후 inactive 처리 예정
        *
* txtpb
* @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/resources/clientlogs/order/misc/common.txtpb#L9}
        * CartOrderFullScreenDialog
* @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/yanolja/clientlog/custom/order/misc.proto#L144}
        */
    impression({
      fullScreenDialogTitle,
      productOptions,
      checkyn,
      fullScreenDialogClickName,
      addOrderPageYn,
    }: CartOrderPageLog.FullScreenDialogTitle.Impression) {
      return KinesisTracker.impression('CART_ORDER', {
        clientEventId: 102,
        pageName: 'PAGE_NAME_CART_ORDER',
        object: fullScreenDialogTitle,
        objectContainer: fullScreenDialogTitle,
        objectType: 'OBJECT_TYPE_FULL_SCREEN_DIALOG',
        eventType: 'EVENT_TYPE_IMPR',
        fullScreenDialogTitle,
        productOptions,
        checkyn,
        fullScreenDialogClickName,
        addOrderPageYn,
      })
    },
  },

  FullScreenDialogTitleCheckboxMaxDiscountBtn: {
    /**
        * 주문페이지 -  쿠폰 할인(풀스크린 다이아로그) - 클릭 - 최대할인적용체크박스
        * https://screen.yanolja.in/4ZoUfFS6F9LUMWTf
앞서 노출에도 남겼지만, objectcontainer를 채우는 것은 현 클라이언트 로그에는 개별 action마다 transactionkey가 없기 때문에
분석시 timestamp를 비롯하여 pair를 맞추기 위한 것.
100% 전환 이후 inactive 처리 예정
        *
* txtpb
* @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/resources/clientlogs/order/misc/common.txtpb#L23}
        * CartOrderFullScreenDialog
* @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/yanolja/clientlog/custom/order/misc.proto#L144}
        */
    click({
      fullScreenDialogTitle,
      productOptions,
      checkyn,
      fullScreenDialogClickName,
      addOrderPageYn,
    }: CartOrderPageLog.FullScreenDialogTitleCheckboxMaxDiscountBtn.Click) {
      return KinesisTracker.click('CART_ORDER', {
        clientEventId: 103,
        pageName: 'PAGE_NAME_CART_ORDER',
        object: 'maxDiscountBtn',
        objectContainer: fullScreenDialogTitle,
        objectType: 'OBJECT_TYPE_CHECKBOX',
        eventType: 'EVENT_TYPE_CLICK',
        fullScreenDialogTitle,
        productOptions,
        checkyn,
        fullScreenDialogClickName,
        addOrderPageYn,
      })
    },
  },

  FullScreenDialogTitleButtonClickName: {
    /**
        * 주문페이지 -  쿠폰 할인(풀스크린 다이아로그) - 클릭 - 쿠폰 관련
        * https://screen.yanolja.in/Xg1lE4MAjbkdtOtV
cusomjson에 정의되어 있는데 편의상 빼내어 표현했음.
100% 전환 이후 inactive 처리 예정
        *
* txtpb
* @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/resources/clientlogs/order/misc/common.txtpb#L38}
        * CartOrderFullScreenDialog
* @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/yanolja/clientlog/custom/order/misc.proto#L144}
        */
    click({
      fullScreenDialogTitle,
      productOptions,
      checkyn,
      fullScreenDialogClickName,
      addOrderPageYn,
    }: CartOrderPageLog.FullScreenDialogTitleButtonClickName.Click) {
      return KinesisTracker.click('CART_ORDER', {
        clientEventId: 104,
        pageName: 'PAGE_NAME_CART_ORDER',
        object: fullScreenDialogClickName,
        objectContainer: fullScreenDialogTitle,
        objectType: 'OBJECT_TYPE_BUTTON',
        eventType: 'EVENT_TYPE_CLICK',
        fullScreenDialogTitle,
        productOptions,
        checkyn,
        fullScreenDialogClickName,
        addOrderPageYn,
      })
    },
  },

  FullScreenDialogTitleButtonCloseBtn: {
    /**
        * 주문페이지 -  쿠폰 할인(풀스크린 다이아로그) - 클릭 - 닫기 버튼
        * https://screen.yanolja.in/eZD7Yc9bVIvJu5ps
100% 전환 이후 inactive 처리 예정
        *
* txtpb
* @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/resources/clientlogs/order/misc/common.txtpb#L52}
        * CartOrderFullScreenDialog
* @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/yanolja/clientlog/custom/order/misc.proto#L144}
        */
    click({
      fullScreenDialogTitle,
      productOptions,
      checkyn,
      fullScreenDialogClickName,
      addOrderPageYn,
    }: CartOrderPageLog.FullScreenDialogTitleButtonCloseBtn.Click) {
      return KinesisTracker.click('CART_ORDER', {
        clientEventId: 105,
        pageName: 'PAGE_NAME_CART_ORDER',
        object: 'closeBtn',
        objectContainer: fullScreenDialogTitle,
        objectType: 'OBJECT_TYPE_BUTTON',
        eventType: 'EVENT_TYPE_CLICK',
        fullScreenDialogTitle,
        productOptions,
        checkyn,
        fullScreenDialogClickName,
        addOrderPageYn,
      })
    },
  },

  FullScreenDialogTitleButtonDiscountArea: {
    /**
        * 주문페이지 -  쿠폰 할인(풀스크린 다이아로그) - 클릭 - 반영 버튼
        * https://screen.yanolja.in/ZVjztwCF5LSqPJOu
100% 전환 이후 inactive 처리 예정
        *
* txtpb
* @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/resources/clientlogs/order/misc/common.txtpb#L65}
        * CartOrderFullScreenDialog
* @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/yanolja/clientlog/custom/order/misc.proto#L144}
        */
    click({
      fullScreenDialogTitle,
      productOptions,
      checkyn,
      fullScreenDialogClickName,
      addOrderPageYn,
    }: CartOrderPageLog.FullScreenDialogTitleButtonDiscountArea.Click) {
      return KinesisTracker.click('CART_ORDER', {
        clientEventId: 106,
        pageName: 'PAGE_NAME_CART_ORDER',
        object: 'discountArea',
        objectContainer: fullScreenDialogTitle,
        objectType: 'OBJECT_TYPE_BUTTON',
        eventType: 'EVENT_TYPE_CLICK',
        fullScreenDialogTitle,
        productOptions,
        checkyn,
        fullScreenDialogClickName,
        addOrderPageYn,
      })
    },
  },

  BottomSheetTitle: {
    /**
        * 주문페이지 -  쿠폰종류 바텀싯 - 노출
        * https://screen.yanolja.in/SXcRkigEjxEXt8mq
100% 전환 이후 inactive 처리 예정
        *
* txtpb
* @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/resources/clientlogs/order/misc/common.txtpb#L78}
        * CartOrderBottomSheet
* @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/yanolja/clientlog/custom/order/misc.proto#L172}
        */
    impression({
      bottomSheetTitle,
      couponOptions,
      bottomSheetClickName,
      addOrderPageYn,
    }: CartOrderPageLog.BottomSheetTitle.Impression) {
      return KinesisTracker.impression('CART_ORDER', {
        clientEventId: 107,
        pageName: 'PAGE_NAME_CART_ORDER',
        object: bottomSheetTitle,
        objectContainer: bottomSheetTitle,
        objectType: 'OBJECT_TYPE_BOTTOM_SHEET',
        eventType: 'EVENT_TYPE_IMPR',
        bottomSheetTitle,
        couponOptions,
        bottomSheetClickName,
        addOrderPageYn,
      })
    },
  },

  BottomSheetTitleButtonCloseBtn: {
    /**
        * 주문페이지 -  쿠폰종류 바텀싯 - 클릭 - 닫기 버튼
        * https://screen.yanolja.in/w11z0JqtROmkhrL4
100% 전환 이후 inactive 처리 예정
        *
* txtpb
* @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/resources/clientlogs/order/misc/common.txtpb#L91}
        * CartOrderBottomSheet
* @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/yanolja/clientlog/custom/order/misc.proto#L172}
        */
    click({
      bottomSheetTitle,
      couponOptions,
      bottomSheetClickName,
      addOrderPageYn,
    }: CartOrderPageLog.BottomSheetTitleButtonCloseBtn.Click) {
      return KinesisTracker.click('CART_ORDER', {
        clientEventId: 108,
        pageName: 'PAGE_NAME_CART_ORDER',
        object: 'closeBtn',
        objectContainer: bottomSheetTitle,
        objectType: 'OBJECT_TYPE_BUTTON',
        eventType: 'EVENT_TYPE_CLICK',
        bottomSheetTitle,
        couponOptions,
        bottomSheetClickName,
        addOrderPageYn,
      })
    },
  },

  BottomSheetTitleButtonClickName: {
    /**
        * 주문페이지 -  쿠폰종류 바텀싯 - 클릭 - 적용 안함 버튼
        * https://screen.yanolja.in/J4rzLkqcN8Tlbwkp
100% 전환 이후 inactive 처리 예정
        *
* txtpb
* @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/resources/clientlogs/order/misc/common.txtpb#L104}
        * CartOrderBottomSheet
* @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/yanolja/clientlog/custom/order/misc.proto#L172}
        */
    click({
      bottomSheetTitle,
      couponOptions,
      bottomSheetClickName,
      addOrderPageYn,
    }: CartOrderPageLog.BottomSheetTitleButtonClickName.Click) {
      return KinesisTracker.click('CART_ORDER', {
        clientEventId: 109,
        pageName: 'PAGE_NAME_CART_ORDER',
        object: bottomSheetClickName,
        objectContainer: bottomSheetTitle,
        objectType: 'OBJECT_TYPE_BUTTON',
        eventType: 'EVENT_TYPE_CLICK',
        bottomSheetTitle,
        couponOptions,
        bottomSheetClickName,
        addOrderPageYn,
      })
    },
  },

  BottomSheetTitleButtonCouponId: {
    /**
     * 주문페이지 -  쿠폰종류 바텀싯 - 클릭 - 쿠폰 종류
     * https://screen.yanolja.in/qk94A2J5T3pKw7eB
     *
     * txtpb
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/resources/clientlogs/order/misc/common.txtpb#L117}
     * CartOrderBottomSheet
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/yanolja/clientlog/custom/order/misc.proto#L172}
     */
    click({
      bottomSheetTitle,
      couponOptions,
      bottomSheetClickName,
      addOrderPageYn,
      couponId,
    }: CartOrderPageLog.BottomSheetTitleButtonCouponId.Click) {
      return KinesisTracker.click('CART_ORDER', {
        clientEventId: 110,
        pageName: 'PAGE_NAME_CART_ORDER',
        object: couponId,
        objectContainer: bottomSheetTitle,
        objectType: 'OBJECT_TYPE_BUTTON',
        eventType: 'EVENT_TYPE_CLICK',
        bottomSheetTitle,
        couponOptions,
        bottomSheetClickName,
        addOrderPageYn,
      })
    },
  },

  CartOrderViewInfo: {
    /**
        * 주문페이지 - 통합 예약 페이지 진입
        * 기존 로그 + add_order_page_yn 만 추가
스크린 : https://screen.yanolja.in/9uSA5U32D8lwcclZ
100% 전환 이후 inactive 처리 예정 - 혜택정보 텍스트 클릭 변경
        *
* txtpb
* @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/resources/clientlogs/order/misc/common.txtpb#L129}
        * CartOrderViewInfo
* @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/yanolja/clientlog/custom/order/misc.proto#L232}
        */
    view({
      isLogin,
      productOptions,
      availableCouponCount,
      fromCartYn,
      addOrderPageYn,
    }: CartOrderPageLog.CartOrderViewInfo.View) {
      return KinesisTracker.view('CART_ORDER', {
        inactive: false,
        clientEventId: 420,
        pageName: 'PAGE_NAME_CART_ORDER',
        eventType: 'EVENT_TYPE_VIEW',
        isLogin,
        productOptions,
        availableCouponCount,
        fromCartYn,
        addOrderPageYn,
      })
    },
  },

  NolCardBanner: {
    /**
        * 주문페이지 - 주문서 NOL 카드 배너 노출
        * 기존 로그 수정
스크린 : https://screen.yanolja.in/ZdG7I2EnQdi30ifA
100% 전환 이후 inactive 처리 예정 - 혜택정보 텍스트 클릭 변경
        *
* txtpb
* @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/resources/clientlogs/order/misc/common.txtpb#L142}
        * CartOrderClick
* @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/yanolja/clientlog/custom/order/misc.proto#L247}
        */
    impression({
      hashOrderId,
      nolCard,
      paymentMethod,
      addOrderPageYn,
    }: CartOrderPageLog.NolCardBanner.Impression) {
      return KinesisTracker.impression('CART_ORDER', {
        clientEventId: 421,
        pageName: 'PAGE_NAME_CART_ORDER',
        object: 'nolCard',
        objectContainer: 'nolCardBanner',
        objectType: 'OBJECT_TYPE_BANNER',
        eventType: 'EVENT_TYPE_IMPR',
        hashOrderId,
        nolCard,
        paymentMethod,
        addOrderPageYn,
      })
    },

    /**
        * 주문페이지 - 주문서 NOL 카드 배너 클릭
        * 기존 로그 수정
스크린 : https://screen.yanolja.in/ZdG7I2EnQdi30ifA
        *
* txtpb
* @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/resources/clientlogs/order/misc/common.txtpb#L156}
        * CartOrderClick
* @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/yanolja/clientlog/custom/order/misc.proto#L247}
        */
    click({
      hashOrderId,
      nolCard,
      paymentMethod,
      addOrderPageYn,
    }: CartOrderPageLog.NolCardBanner.Click) {
      return KinesisTracker.click('CART_ORDER', {
        clientEventId: 422,
        pageName: 'PAGE_NAME_CART_ORDER',
        object: 'nolCard',
        objectContainer: 'nolCardBanner',
        objectType: 'OBJECT_TYPE_BANNER',
        eventType: 'EVENT_TYPE_CLICK',
        hashOrderId,
        nolCard,
        paymentMethod,
        addOrderPageYn,
      })
    },
  },

  PaymentButtonMethod: {
    /**
        * 주문페이지 - 결제수단 선택 클릭
        * 기존 로그 수정
스크린 : https://screen.yanolja.in/TyxEcbSMfBcq3POi.png
100% 전환 이후 inactive 처리 예정
        *
* txtpb
* @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/resources/clientlogs/order/misc/common.txtpb#L169}
        * CartOrderClick
* @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/yanolja/clientlog/custom/order/misc.proto#L247}
        */
    click({
      hashOrderId,
      nolCard,
      paymentMethod,
      addOrderPageYn,
    }: CartOrderPageLog.PaymentButtonMethod.Click) {
      return KinesisTracker.click('CART_ORDER', {
        inactive: false,
        clientEventId: 423,
        pageName: 'PAGE_NAME_CART_ORDER',
        object: 'paymentMethod',
        objectContainer: 'payment',
        objectType: 'OBJECT_TYPE_BUTTON',
        eventType: 'EVENT_TYPE_CLICK',
        hashOrderId,
        nolCard,
        paymentMethod,
        addOrderPageYn,
      })
    },
  },

  PaymentButtonBtn: {
    /**
        * 주문페이지 - 결제하기 버튼 클릭
        * 기존 로그 수정
스크린 : https://screen.yanolja.in/99kFQ7BzDY2cga2Z
        *
* txtpb
* @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/resources/clientlogs/order/misc/common.txtpb#L184}
        * CartOrderClick
* @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/yanolja/clientlog/custom/order/misc.proto#L247}
        */
    click({
      hashOrderId,
      nolCard,
      paymentMethod,
      addOrderPageYn,
    }: CartOrderPageLog.PaymentButtonBtn.Click) {
      return KinesisTracker.click('CART_ORDER', {
        clientEventId: 424,
        pageName: 'PAGE_NAME_CART_ORDER',
        object: 'paymentBtn',
        objectContainer: 'payment',
        objectType: 'OBJECT_TYPE_BUTTON',
        eventType: 'EVENT_TYPE_CLICK',
        hashOrderId,
        nolCard,
        paymentMethod,
        addOrderPageYn,
      })
    },
  },

  PopupOrderFailed: {
    /**
     * 주문페이지 - 주문 실패 팝업 노출
     * 스크린 : https://screen.yanolja.in/w834gUMGtlV8x4jE
     *
     * txtpb
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/resources/clientlogs/order/misc/common.txtpb#L197}
     * CartOrderPopup
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/yanolja/clientlog/custom/order/misc.proto#L254}
     */
    impression({
      hashOrderId,
      popupTitle,
      addOrderPageYn,
    }: CartOrderPageLog.PopupOrderFailed.Impression) {
      return KinesisTracker.impression('CART_ORDER', {
        inactive: false,
        clientEventId: 425,
        pageName: 'PAGE_NAME_CART_ORDER',
        object: 'orderFailedPopup',
        objectType: 'OBJECT_TYPE_POPUP',
        eventType: 'EVENT_TYPE_IMPR',
        hashOrderId,
        popupTitle,
        addOrderPageYn,
      })
    },
  },

  BannerTimer: {
    /**
     * 주문페이지 - 타이머 노출
     * 스크린 : https://screen.yanolja.in/r9ygsYfrFl0qJPAV
     *
     * txtpb
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/resources/clientlogs/order/misc/common.txtpb#L210}
     * CartOrderCommon
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/yanolja/clientlog/custom/order/misc.proto#L242}
     */
    impression({ hashOrderId, addOrderPageYn }: CartOrderPageLog.BannerTimer.Impression) {
      return KinesisTracker.impression('CART_ORDER', {
        inactive: false,
        clientEventId: 426,
        pageName: 'PAGE_NAME_CART_ORDER',
        object: 'timer',
        objectType: 'OBJECT_TYPE_BANNER',
        eventType: 'EVENT_TYPE_IMPR',
        hashOrderId,
        addOrderPageYn,
      })
    },
  },

  PointTypeCheckboxSave: {
    /**
     * 주문페이지 - (체크박스) 노출 - (어떤 포인트이던) 포인트관련 적립
     * 스크린 : https://screen.yanolja.in/20ViU4ponEx0B2rE
     *
     * txtpb
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/resources/clientlogs/order/misc/common.txtpb#L223}
     * CartOrderPointClick
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/yanolja/clientlog/custom/order/misc.proto#L260}
     */
    impression({
      hashOrderId,
      addOrderPageYn,
      checkYn,
      clickName,
      pointType,
    }: CartOrderPageLog.PointTypeCheckboxSave.Impression) {
      return KinesisTracker.impression('CART_ORDER', {
        inactive: false,
        clientEventId: 470,
        pageName: 'PAGE_NAME_CART_ORDER',
        object: 'savePoint',
        objectContainer: 'pointType',
        objectType: 'OBJECT_TYPE_CHECKBOX',
        eventType: 'EVENT_TYPE_IMPR',
        hashOrderId,
        addOrderPageYn,
        checkYn,
        clickName,
        pointType,
      })
    },
  },

  PointTypeCheckboxCheckYn: {
    /**
     * 주문페이지 - (모든 체크박스) 클릭 - CJONE 적립하기 영역
     * 스크린 : https://screen.yanolja.in/20ViU4ponEx0B2rE
     *
     * txtpb
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/resources/clientlogs/order/misc/common.txtpb#L236}
     * CartOrderPointClick
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/yanolja/clientlog/custom/order/misc.proto#L260}
     */
    click({
      hashOrderId,
      addOrderPageYn,
      checkYn,
      clickName,
      pointType,
    }: CartOrderPageLog.PointTypeCheckboxCheckYn.Click) {
      return KinesisTracker.click('CART_ORDER', {
        inactive: false,
        clientEventId: 471,
        pageName: 'PAGE_NAME_CART_ORDER',
        object: 'checkYn',
        objectContainer: 'pointType',
        objectType: 'OBJECT_TYPE_CHECKBOX',
        eventType: 'EVENT_TYPE_CLICK',
        hashOrderId,
        addOrderPageYn,
        checkYn,
        clickName,
        pointType,
      })
    },
  },

  PointTypeButtonClickName: {
    /**
        * 주문페이지 - (모든 버튼) 클릭 - 포인트 관련 (eg. 전액사용, X(삭제하기), 연동하기 등)
        * 스크린 : https://screen.yanolja.in/als3CqJ82mn7Ae1A
################################### CartOrder CX 개선 이후 추가 로그 ####################################
        *
* txtpb
* @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/resources/clientlogs/order/misc/common.txtpb#L249}
        * CartOrderPointClick
* @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/yanolja/clientlog/custom/order/misc.proto#L260}
        */
    click({
      hashOrderId,
      addOrderPageYn,
      checkYn,
      clickName,
      pointType,
    }: CartOrderPageLog.PointTypeButtonClickName.Click) {
      return KinesisTracker.click('CART_ORDER', {
        inactive: false,
        clientEventId: 472,
        pageName: 'PAGE_NAME_CART_ORDER',
        object: 'clickName',
        objectContainer: 'pointType',
        objectType: 'OBJECT_TYPE_BUTTON',
        eventType: 'EVENT_TYPE_CLICK',
        hashOrderId,
        addOrderPageYn,
        checkYn,
        clickName,
        pointType,
      })
    },
  },

  ButtonBackward: {
    /**
     * 주문페이지 - 클릭 - 뒤로가기 - 버튼
     * 구 로그번호 : 없음(object = backwardBtn)
     *
     * txtpb
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/resources/clientlogs/order/misc/common.txtpb#L264}
     */
    click({}: CartOrderPageLog.ButtonBackward.Click = {}) {
      return KinesisTracker.click('CART_ORDER', {
        inactive: false,
        clientEventId: 1483,
        pageName: 'PAGE_NAME_CART_ORDER',
        object: 'backward',
        objectType: 'OBJECT_TYPE_BUTTON',
        eventType: 'EVENT_TYPE_CLICK',
      })
    },
  },

  HeaderTextLogin: {
    /**
     * 주문페이지 - 클릭 - 상단로그인(앱만 제공) - 텍스트
     * 구 로그번호 : 없음(object = topLoginBtn)
     *
     * txtpb
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/resources/clientlogs/order/misc/common.txtpb#L275}
     */
    click({}: CartOrderPageLog.HeaderTextLogin.Click = {}) {
      return KinesisTracker.click('CART_ORDER', {
        inactive: false,
        clientEventId: 1484,
        pageName: 'PAGE_NAME_CART_ORDER',
        object: 'login',
        objectContainer: 'header',
        objectType: 'OBJECT_TYPE_TEXT',
        eventType: 'EVENT_TYPE_CLICK',
      })
    },
  },

  ButtonLogin: {
    /**
     * 주문페이지 - 클릭 - 로그인후 할인혜택 - 버튼
     * 구 로그번호 : 없음(object = loginBtn)
     *
     * txtpb
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/resources/clientlogs/order/misc/common.txtpb#L287}
     */
    click({}: CartOrderPageLog.ButtonLogin.Click = {}) {
      return KinesisTracker.click('CART_ORDER', {
        inactive: false,
        clientEventId: 1485,
        pageName: 'PAGE_NAME_CART_ORDER',
        object: 'login',
        objectType: 'OBJECT_TYPE_BUTTON',
        eventType: 'EVENT_TYPE_CLICK',
      })
    },
  },

  BannerFreeCancelInfo: {
    /**
     * 주문페이지 - 노출 - 국내숙소 상단무료취소안내 - 배너
     * 국내숙소 예외취소 정책 : 취소수수료가 부과되는 경우 예약 완료 후 일정 시간 이내에 무료로 취소할 수 있는 상위 플랫폼 정책
     *
     * txtpb
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/resources/clientlogs/order/misc/common.txtpb#L298}
     * FreeCancelInfo
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/yanolja/clientlog/custom/order/misc.proto#L670}
     */
    impression({ productOptions }: CartOrderPageLog.BannerFreeCancelInfo.Impression) {
      return KinesisTracker.impression('CART_ORDER', {
        inactive: false,
        clientEventId: 1486,
        pageName: 'PAGE_NAME_CART_ORDER',
        object: 'freeCancelInfo',
        objectType: 'OBJECT_TYPE_BANNER',
        eventType: 'EVENT_TYPE_IMPR',
        productOptions,
      })
    },
  },

  ButtonFreeCancelInfo: {
    /**
     * 주문페이지 - 클릭 - 국내숙소 상단무료취소안내 - 버튼
     * 국내숙소 예외취소 정책 : 취소수수료가 부과되는 경우 예약 완료 후 일정 시간 이내에 무료로 취소할 수 있는 상위 플랫폼 정책
     *
     * txtpb
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/resources/clientlogs/order/misc/common.txtpb#L311}
     * FreeCancelInfo
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/yanolja/clientlog/custom/order/misc.proto#L670}
     */
    click({ productOptions }: CartOrderPageLog.ButtonFreeCancelInfo.Click) {
      return KinesisTracker.click('CART_ORDER', {
        inactive: false,
        clientEventId: 1487,
        pageName: 'PAGE_NAME_CART_ORDER',
        object: 'freeCancelInfo',
        objectType: 'OBJECT_TYPE_BUTTON',
        eventType: 'EVENT_TYPE_CLICK',
        productOptions,
      })
    },
  },

  TextChangePhone: {
    /**
     * 주문페이지 - 클릭 - 회원 계정관리 - 텍스트
     * 구 로그번호 : 없음(object = changePhoneBtn)
     *
     * txtpb
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/resources/clientlogs/order/misc/common.txtpb#L324}
     */
    click({}: CartOrderPageLog.TextChangePhone.Click = {}) {
      return KinesisTracker.click('CART_ORDER', {
        inactive: false,
        clientEventId: 1488,
        pageName: 'PAGE_NAME_CART_ORDER',
        object: 'changePhone',
        objectType: 'OBJECT_TYPE_TEXT',
        eventType: 'EVENT_TYPE_CLICK',
      })
    },
  },

  ButtonVerifyIdentity: {
    /**
     * 주문페이지 - 클릭 - 휴대폰 번호 인증하기 - 버튼
     *
     * txtpb
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/resources/clientlogs/order/misc/common.txtpb#L335}
     */
    click({}: CartOrderPageLog.ButtonVerifyIdentity.Click = {}) {
      return KinesisTracker.click('CART_ORDER', {
        inactive: false,
        clientEventId: 1489,
        pageName: 'PAGE_NAME_CART_ORDER',
        object: 'verifyIdentity',
        objectType: 'OBJECT_TYPE_BUTTON',
        eventType: 'EVENT_TYPE_CLICK',
      })
    },
  },

  CompletedVerifyIdentity: {
    /**
     * 주문페이지 - 본인인증 완료시
     *
     * txtpb
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/resources/clientlogs/order/misc/common.txtpb#L346}
     */
    bg({}: CartOrderPageLog.CompletedVerifyIdentity.Bg = {}) {
      return KinesisTracker.bg('CART_ORDER', {
        inactive: false,
        clientEventId: 1490,
        pageName: 'PAGE_NAME_CART_ORDER',
        object: 'completedVerifyIdentity',
        eventType: 'EVENT_TYPE_BG',
      })
    },
  },

  DiscountSectionButton: {
    /**
     * 주문페이지 - 할인영역 - 클릭 - 쿠폰할인 - 버튼
     * 구 로그번호 : 없음(object = discountBtn)
     *
     * txtpb
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/resources/clientlogs/order/misc/common.txtpb#L356}
     * CartOrderDiscountButton
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/yanolja/clientlog/custom/order/misc.proto#L634}
     */
    click({
      productOptions,
      addOrderPageYn,
      couponBoxTitle,
    }: CartOrderPageLog.DiscountSectionButton.Click) {
      return KinesisTracker.click('CART_ORDER', {
        inactive: false,
        clientEventId: 1491,
        pageName: 'PAGE_NAME_CART_ORDER',
        object: 'discount',
        objectContainer: 'discountSection',
        objectType: 'OBJECT_TYPE_BUTTON',
        eventType: 'EVENT_TYPE_CLICK',
        productOptions,
        addOrderPageYn,
        couponBoxTitle,
      })
    },
  },

  DiscountSectionCheckboxMax: {
    /**
     * 주문페이지 - 클릭 - 최대할인적용 - 체크박스
     * 구 로그번호 : 없음(object = maxDiscountBtn)
     *
     * txtpb
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/resources/clientlogs/order/misc/common.txtpb#L369}
     * CartOrderMaxDiscountCheck
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/yanolja/clientlog/custom/order/misc.proto#L559}
     */
    click({ checkYn }: CartOrderPageLog.DiscountSectionCheckboxMax.Click) {
      return KinesisTracker.click('CART_ORDER', {
        inactive: false,
        clientEventId: 1492,
        pageName: 'PAGE_NAME_CART_ORDER',
        object: 'maxDiscount',
        objectContainer: 'discountSection',
        objectType: 'OBJECT_TYPE_CHECKBOX',
        eventType: 'EVENT_TYPE_CLICK',
        checkYn,
      })
    },
  },

  DiscountSelectionRadioClickName: {
    /**
     * 주문페이지 - 할인선택 풀스크린 다이아로그 - 클릭 - 라디오버튼
     *
     * txtpb
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/resources/clientlogs/order/misc/common.txtpb#L383}
     * CartOrderDiscountSelectionClick
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/yanolja/clientlog/custom/order/misc.proto#L584}
     */
    click({
      productOptions,
      addOrderPageYn,
      clickName,
      orderDiscounts,
    }: CartOrderPageLog.DiscountSelectionRadioClickName.Click) {
      return KinesisTracker.click('CART_ORDER', {
        inactive: false,
        clientEventId: 1493,
        pageName: 'PAGE_NAME_CART_ORDER',
        object: 'clickName',
        objectContainer: 'discountSelection',
        objectType: 'OBJECT_TYPE_RADIO',
        eventType: 'EVENT_TYPE_CLICK',
        productOptions,
        addOrderPageYn,
        clickName,
        orderDiscounts,
      })
    },
  },

  DiscountSelectionCheckboxMax: {
    /**
     * 주문페이지 - 할인선택 풀스크린 다이아로그 - 클릭 - 최대할인적용 - 체크박스
     * 구 로그번호 : 103
     *
     * txtpb
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/resources/clientlogs/order/misc/common.txtpb#L397}
     * CartOrderDiscountSelectionMaxDiscount
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/yanolja/clientlog/custom/order/misc.proto#L598}
     */
    click({
      productOptions,
      checkYn,
      addOrderPageYn,
    }: CartOrderPageLog.DiscountSelectionCheckboxMax.Click) {
      return KinesisTracker.click('CART_ORDER', {
        inactive: false,
        clientEventId: 1494,
        pageName: 'PAGE_NAME_CART_ORDER',
        object: 'maxDiscount',
        objectContainer: 'discountSelection',
        objectType: 'OBJECT_TYPE_CHECKBOX',
        eventType: 'EVENT_TYPE_CLICK',
        productOptions,
        checkYn,
        addOrderPageYn,
      })
    },
  },

  DiscountSelectionDropdownFilterClickName: {
    /**
     * 주문페이지 - 할인선택 풀스크린 다이아로그 - 클릭 - 할인쿠폰/더하기쿠폰 - 드롭다운
     * 구 로그번호 : 104
     *
     * txtpb
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/resources/clientlogs/order/misc/common.txtpb#L410}
     * CartOrderDiscountSelectionCouponClick
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/yanolja/clientlog/custom/order/misc.proto#L591}
     */
    click({
      productOptions,
      clickName,
      addOrderPageYn,
    }: CartOrderPageLog.DiscountSelectionDropdownFilterClickName.Click) {
      return KinesisTracker.click('CART_ORDER', {
        inactive: false,
        clientEventId: 1495,
        pageName: 'PAGE_NAME_CART_ORDER',
        object: 'clickName',
        objectContainer: 'discountSelection',
        objectType: 'OBJECT_TYPE_DROPDOWN_FILTER',
        eventType: 'EVENT_TYPE_CLICK',
        productOptions,
        clickName,
        addOrderPageYn,
      })
    },
  },

  DiscountSelectionButtonClose: {
    /**
     * 주문페이지 - 할인선택 풀스크린 다이아로그 - 클릭 - 닫기 - 버튼
     * 구 로그번호 : 105
     *
     * txtpb
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/resources/clientlogs/order/misc/common.txtpb#L423}
     * CartOrderDiscountSelection
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/yanolja/clientlog/custom/order/misc.proto#L571}
     */
    click({
      productOptions,
      addOrderPageYn,
      orderDiscounts,
    }: CartOrderPageLog.DiscountSelectionButtonClose.Click) {
      return KinesisTracker.click('CART_ORDER', {
        inactive: false,
        clientEventId: 1496,
        pageName: 'PAGE_NAME_CART_ORDER',
        object: 'close',
        objectContainer: 'discountSelection',
        objectType: 'OBJECT_TYPE_BUTTON',
        eventType: 'EVENT_TYPE_CLICK',
        productOptions,
        addOrderPageYn,
        orderDiscounts,
      })
    },
  },

  DiscountSelectionButtonApply: {
    /**
     * 주문페이지 - 할인선택 풀스크린 다이아로그 - 클릭 - 할인적용하기 - 버튼
     * 구 로그번호 : 106
     *
     * txtpb
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/resources/clientlogs/order/misc/common.txtpb#L436}
     * CartOrderDiscountSelection
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/yanolja/clientlog/custom/order/misc.proto#L571}
     */
    click({
      productOptions,
      addOrderPageYn,
      orderDiscounts,
    }: CartOrderPageLog.DiscountSelectionButtonApply.Click) {
      return KinesisTracker.click('CART_ORDER', {
        inactive: false,
        clientEventId: 1497,
        pageName: 'PAGE_NAME_CART_ORDER',
        object: 'discountApply',
        objectContainer: 'discountSelection',
        objectType: 'OBJECT_TYPE_BUTTON',
        eventType: 'EVENT_TYPE_CLICK',
        productOptions,
        addOrderPageYn,
        orderDiscounts,
      })
    },
  },

  BottomSheetCouponSelection: {
    /**
     * 주문페이지 - 할인쿠폰 선택 바텀시트 - 노출
     * 구 로그번호 : 107
     *
     * txtpb
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/resources/clientlogs/order/misc/common.txtpb#L449}
     * CartOrderCouponSelectionImpr
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/yanolja/clientlog/custom/order/misc.proto#L651}
     */
    impression({
      couponOptions,
      addOrderPageYn,
    }: CartOrderPageLog.BottomSheetCouponSelection.Impression) {
      return KinesisTracker.impression('CART_ORDER', {
        inactive: false,
        clientEventId: 1498,
        pageName: 'PAGE_NAME_CART_ORDER',
        object: 'couponSelection',
        objectContainer: 'couponSelection',
        objectType: 'OBJECT_TYPE_BOTTOM_SHEET',
        eventType: 'EVENT_TYPE_IMPR',
        couponOptions,
        addOrderPageYn,
      })
    },
  },

  CouponSelectionButtonClickName: {
    /**
     * 주문페이지 - 할인쿠폰 선택 바텀시트 - 클릭 - 적용안함/쿠폰종류 - 버튼
     * 구 로그번호 : 109,110
     *
     * txtpb
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/resources/clientlogs/order/misc/common.txtpb#L462}
     * CartOrderCouponSelectionClick
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/yanolja/clientlog/custom/order/misc.proto#L659}
     */
    click({
      couponOptions,
      clickName,
      addOrderPageYn,
    }: CartOrderPageLog.CouponSelectionButtonClickName.Click) {
      return KinesisTracker.click('CART_ORDER', {
        inactive: false,
        clientEventId: 1499,
        pageName: 'PAGE_NAME_CART_ORDER',
        object: 'clickName',
        objectContainer: 'couponSelection',
        objectType: 'OBJECT_TYPE_BUTTON',
        eventType: 'EVENT_TYPE_CLICK',
        couponOptions,
        clickName,
        addOrderPageYn,
      })
    },
  },

  CouponSelectionButtonApply: {
    /**
     * 주문페이지 - 할인쿠폰 선택 바텀시트 - 클릭 - 적용하기 - 버튼
     *
     * txtpb
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/resources/clientlogs/order/misc/common.txtpb#L475}
     * CartOrderCouponSelectionClick
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/yanolja/clientlog/custom/order/misc.proto#L659}
     */
    click({
      couponOptions,
      clickName,
      addOrderPageYn,
    }: CartOrderPageLog.CouponSelectionButtonApply.Click) {
      return KinesisTracker.click('CART_ORDER', {
        inactive: false,
        clientEventId: 1500,
        pageName: 'PAGE_NAME_CART_ORDER',
        object: 'couponApply',
        objectContainer: 'couponSelection',
        objectType: 'OBJECT_TYPE_BUTTON',
        eventType: 'EVENT_TYPE_CLICK',
        couponOptions,
        clickName,
        addOrderPageYn,
      })
    },
  },

  ButtonPayment: {
    /**
     * 주문페이지 - 클릭 - 결제하기 - 버튼
     * 구 로그번호 : 424
     *
     * txtpb
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/resources/clientlogs/order/misc/common.txtpb#L488}
     * CartOrderPayment
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/yanolja/clientlog/custom/order/misc.proto#L611}
     */
    click({
      addOrderPageYn,
      pgType,
      productOptions,
      orderAmount,
      pointAmount,
      packageDiscountAmount,
      pgAmount,
      couponAmount,
      nolPointAmount,
      isMaxDiscountApplied,
      isSameAsBooker,
      rewardBenefit,
    }: CartOrderPageLog.ButtonPayment.Click) {
      return KinesisTracker.click('CART_ORDER', {
        inactive: false,
        clientEventId: 1501,
        pageName: 'PAGE_NAME_CART_ORDER',
        object: 'payment',
        objectType: 'OBJECT_TYPE_BUTTON',
        eventType: 'EVENT_TYPE_CLICK',
        addOrderPageYn,
        pgType,
        productOptions,
        orderAmount,
        pointAmount,
        packageDiscountAmount,
        pgAmount,
        couponAmount,
        nolPointAmount,
        isMaxDiscountApplied,
        isSameAsBooker,
        rewardBenefit,
      })
    },
  },

  BenefitInfoTextType: {
    /**
     * 주문페이지 - 혜택정보 - 노출 - 혜택 - 텍스트
     * 구 로그번호 : 421
     *
     * txtpb
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/resources/clientlogs/order/misc/common.txtpb#L500}
     * CartOrderBenefitInfo
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/yanolja/clientlog/custom/order/misc.proto#L604}
     */
    impression({ benefitType, benefitSubType }: CartOrderPageLog.BenefitInfoTextType.Impression) {
      return KinesisTracker.impression('CART_ORDER', {
        inactive: false,
        clientEventId: 1502,
        pageName: 'PAGE_NAME_CART_ORDER',
        object: 'benefitType',
        objectContainer: 'benefitInfo',
        objectType: 'OBJECT_TYPE_TEXT',
        eventType: 'EVENT_TYPE_IMPR',
        benefitType,
        benefitSubType,
      })
    },

    /**
     * 주문페이지 - 혜택정보 - 클릭 - 혜택 - 텍스트
     * 구 로그번호 : 422
     *
     * txtpb
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/resources/clientlogs/order/misc/common.txtpb#L513}
     * CartOrderBenefitInfo
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/yanolja/clientlog/custom/order/misc.proto#L604}
     */
    click({ benefitType, benefitSubType }: CartOrderPageLog.BenefitInfoTextType.Click) {
      return KinesisTracker.click('CART_ORDER', {
        inactive: false,
        clientEventId: 1503,
        pageName: 'PAGE_NAME_CART_ORDER',
        object: 'benefitType',
        objectContainer: 'benefitInfo',
        objectType: 'OBJECT_TYPE_TEXT',
        eventType: 'EVENT_TYPE_CLICK',
        benefitType,
        benefitSubType,
      })
    },
  },

  DiscountSectionTextBenefitType: {
    /**
        * 주문페이지 - 할인영역 - 노출 - 혜택(NOL카드) - 텍스트
        * NOL카드 미발급자에 한해 노출
구 로그번호 : 없음(object = nolCoupon)
        *
* txtpb
* @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/resources/clientlogs/order/misc/common.txtpb#L526}
        * CartOrderBenefitInfo
* @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/yanolja/clientlog/custom/order/misc.proto#L604}
        */
    impression({
      benefitType,
      benefitSubType,
    }: CartOrderPageLog.DiscountSectionTextBenefitType.Impression) {
      return KinesisTracker.impression('CART_ORDER', {
        inactive: false,
        clientEventId: 1504,
        pageName: 'PAGE_NAME_CART_ORDER',
        object: 'benefitType',
        objectContainer: 'discountSection',
        objectType: 'OBJECT_TYPE_TEXT',
        eventType: 'EVENT_TYPE_IMPR',
        benefitType,
        benefitSubType,
      })
    },

    /**
     * 주문페이지 - 할인영역 - 클릭 - 혜택(NOL카드) - 텍스트
     * 구 로그번호 : 없음(object = nolCoupon)
     *
     * txtpb
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/resources/clientlogs/order/misc/common.txtpb#L540}
     * CartOrderBenefitInfo
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/yanolja/clientlog/custom/order/misc.proto#L604}
     */
    click({ benefitType, benefitSubType }: CartOrderPageLog.DiscountSectionTextBenefitType.Click) {
      return KinesisTracker.click('CART_ORDER', {
        inactive: false,
        clientEventId: 1505,
        pageName: 'PAGE_NAME_CART_ORDER',
        object: 'benefitType',
        objectContainer: 'discountSection',
        objectType: 'OBJECT_TYPE_TEXT',
        eventType: 'EVENT_TYPE_CLICK',
        benefitType,
        benefitSubType,
      })
    },
  },

  ProductInfoButtonFreeCancel: {
    /**
     * 주문페이지 - 상품정보 - 클릭 - 취소규정(배너) - 클릭
     *
     * txtpb
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/resources/clientlogs/order/misc/common.txtpb#L553}
     * CartOrderProductCategory
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/yanolja/clientlog/custom/order/misc.proto#L674}
     */
    click({ productCategory }: CartOrderPageLog.ProductInfoButtonFreeCancel.Click) {
      return KinesisTracker.click('CART_ORDER', {
        inactive: false,
        clientEventId: 1506,
        pageName: 'PAGE_NAME_CART_ORDER',
        object: 'productFreeCancelInfo',
        objectContainer: 'productInfo',
        objectType: 'OBJECT_TYPE_BUTTON',
        eventType: 'EVENT_TYPE_CLICK',
        productCategory,
      })
    },
  },

  BottomSheetReservationConfirm: {
    /**
     * 주문페이지 - 결제 전 예약정보 확인 바텀시트 - 노출
     *
     * txtpb
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/resources/clientlogs/order/misc/common.txtpb#L566}
     * FreeCancelInfo
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/yanolja/clientlog/custom/order/misc.proto#L670}
     */
    impression({ productOptions }: CartOrderPageLog.BottomSheetReservationConfirm.Impression) {
      return KinesisTracker.impression('CART_ORDER', {
        inactive: false,
        clientEventId: 1560,
        pageName: 'PAGE_NAME_CART_ORDER',
        object: 'reservationConfirm',
        objectContainer: 'reservationConfirm',
        objectType: 'OBJECT_TYPE_BOTTOM_SHEET',
        eventType: 'EVENT_TYPE_IMPR',
        productOptions,
      })
    },
  },

  ReservationConfirmButtonClickName: {
    /**
     * 주문페이지 - 결제 전 예약정보 확인 바텀시트 - 클릭 - 버튼(이전화면가기/결제하기)
     *
     * txtpb
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/resources/clientlogs/order/misc/common.txtpb#L579}
     * CartOrderReservationClick
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/yanolja/clientlog/custom/order/misc.proto#L813}
     */
    click({ productOptions, clickName }: CartOrderPageLog.ReservationConfirmButtonClickName.Click) {
      return KinesisTracker.click('CART_ORDER', {
        inactive: false,
        clientEventId: 1561,
        pageName: 'PAGE_NAME_CART_ORDER',
        object: 'clickName',
        objectContainer: 'reservationConfirm',
        objectType: 'OBJECT_TYPE_BUTTON',
        eventType: 'EVENT_TYPE_CLICK',
        productOptions,
        clickName,
      })
    },
  },

  FullScreenDialogError: {
    /**
     * 주문페이지 - 에러 화면 - 노출
     *
     * txtpb
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/resources/clientlogs/order/misc/common.txtpb#L592}
     * CartOrderError
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/yanolja/clientlog/custom/order/misc.proto#L819}
     */
    impression({ errorTitle, clickName }: CartOrderPageLog.FullScreenDialogError.Impression) {
      return KinesisTracker.impression('CART_ORDER', {
        inactive: false,
        clientEventId: 1340,
        pageName: 'PAGE_NAME_CART_ORDER',
        object: 'Error',
        objectContainer: 'Error',
        objectType: 'OBJECT_TYPE_FULL_SCREEN_DIALOG',
        eventType: 'EVENT_TYPE_IMPR',
        errorTitle,
        clickName,
      })
    },
  },

  ErrorButtonClickName: {
    /**
     * 주문페이지 - 에러 화면 - 클릭
     *
     * txtpb
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/resources/clientlogs/order/misc/common.txtpb#L605}
     * CartOrderError
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/yanolja/clientlog/custom/order/misc.proto#L819}
     */
    click({ errorTitle, clickName }: CartOrderPageLog.ErrorButtonClickName.Click) {
      return KinesisTracker.click('CART_ORDER', {
        inactive: false,
        clientEventId: 1341,
        pageName: 'PAGE_NAME_CART_ORDER',
        object: 'clickName',
        objectContainer: 'Error',
        objectType: 'OBJECT_TYPE_BUTTON',
        eventType: 'EVENT_TYPE_CLICK',
        errorTitle,
        clickName,
      })
    },
  },

  TermsSectionCheckboxClickName: {
    /**
        * 통합주문 - 클릭 - 약관동의 체크박스
        * ################################### 주문 완료(CART_ORDER_COMPLETE) 로그 START ####################################
100% 전환 이후 inactive 처리 예정
        *
* txtpb
* @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/resources/clientlogs/order/misc/common.txtpb#L618}
        * CartOrderTermsClick
* @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/yanolja/clientlog/custom/order/misc.proto#L825}
        */
    click({ isLogin, clickName, isChecked }: CartOrderPageLog.TermsSectionCheckboxClickName.Click) {
      return KinesisTracker.click('CART_ORDER', {
        inactive: false,
        clientEventId: 2137,
        pageName: 'PAGE_NAME_CART_ORDER',
        object: 'clickName',
        objectContainer: 'termsSection',
        objectType: 'OBJECT_TYPE_CHECKBOX',
        eventType: 'EVENT_TYPE_CLICK',
        isLogin,
        clickName,
        isChecked,
      })
    },
  },

  PaymentNolMoneyButtonClickName: {
    /**
     * 주문페이지 - 결제수단 NOL머니 관련 클릭 버튼
     * 스크린 : https://screen.yanolja.in/HiNEfONERvx1KEhA
     *
     * txtpb
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/resources/clientlogs/order/misc/common.txtpb#L1094}
     * CartOrderNolMoneyClick
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/yanolja/clientlog/custom/order/misc.proto#L268}
     */
    click({
      addOrderPageYn,
      clickName,
      nolmoneyRegisterYn,
      accountRegistrationYn,
    }: CartOrderPageLog.PaymentNolMoneyButtonClickName.Click) {
      return KinesisTracker.click('CART_ORDER', {
        clientEventId: 640,
        pageName: 'PAGE_NAME_CART_ORDER',
        object: 'clickName',
        objectContainer: 'paymentNolMoney',
        objectType: 'OBJECT_TYPE_BUTTON',
        eventType: 'EVENT_TYPE_CLICK',
        addOrderPageYn,
        clickName,
        nolmoneyRegisterYn,
        accountRegistrationYn,
      })
    },
  },

  PaymentNolMoneyPopupButtonClickName: {
    /**
     * 주문페이지 - 결제하기 버튼 클릭 후 계좌 연결 팝업 - 클릭
     * 스크린샷 : https://screen.yanolja.in/Z7IbK9Eb0oOsWk69
     *
     * txtpb
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/resources/clientlogs/order/misc/common.txtpb#L1107}
     * CartOrderNolMoneyPopupClick
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/yanolja/clientlog/custom/order/misc.proto#L276}
     */
    click({
      clickName,
      nolmoneyRegisterYn,
      accountRegistrationYn,
    }: CartOrderPageLog.PaymentNolMoneyPopupButtonClickName.Click) {
      return KinesisTracker.click('CART_ORDER', {
        clientEventId: 641,
        pageName: 'PAGE_NAME_CART_ORDER',
        object: 'clickName',
        objectContainer: 'paymentNolMoneyPopup',
        objectType: 'OBJECT_TYPE_BUTTON',
        eventType: 'EVENT_TYPE_CLICK',
        clickName,
        nolmoneyRegisterYn,
        accountRegistrationYn,
      })
    },
  },

  NolMoneyCertifyBottomSheetButton: {
    /**
        * 주문페이지 - NOL머니 본인 인증하기 bottomsheet - 클릭
        * 화면 : https://screen.yanolja.in/NLsGOJuXf3Kr7lZH
######################### 현금 영수증 로그 ##########################
        *
* txtpb
* @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/resources/clientlogs/order/misc/common.txtpb#L1120}
                    */
    click({}: CartOrderPageLog.NolMoneyCertifyBottomSheetButton.Click = {}) {
      return KinesisTracker.click('CART_ORDER', {
        clientEventId: 642,
        pageName: 'PAGE_NAME_CART_ORDER',
        object: 'nolMoneyCertify',
        objectContainer: 'nolMoneyCertifyBottomSheet',
        objectType: 'OBJECT_TYPE_BUTTON',
        eventType: 'EVENT_TYPE_CLICK',
      })
    },
  },

  WidgetCashReceipt: {
    /**
     * 주문페이지 - 현금 영수증 영역 - 노출
     *
     * txtpb
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/resources/clientlogs/order/misc/common.txtpb#L1133}
     * OrderCashReceipt
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/yanolja/clientlog/custom/order/misc.proto#L307}
     */
    impression({
      checkYn,
      receiptType,
      dropdownOption,
      maskedInputValue,
      inputEventType,
    }: CartOrderPageLog.WidgetCashReceipt.Impression) {
      return KinesisTracker.impression('CART_ORDER', {
        inactive: false,
        clientEventId: 857,
        pageName: 'PAGE_NAME_CART_ORDER',
        object: 'cashReceipt',
        objectType: 'OBJECT_TYPE_WIDGET',
        eventType: 'EVENT_TYPE_IMPR',
        checkYn,
        receiptType,
        dropdownOption,
        maskedInputValue,
        inputEventType,
      })
    },
  },

  CashReceiptCheckbox: {
    /**
     * 주문페이지 - 현금 영수증 신청하기 체크박스 - 클릭
     *
     * txtpb
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/resources/clientlogs/order/misc/common.txtpb#L1145}
     * OrderCashReceipt
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/yanolja/clientlog/custom/order/misc.proto#L307}
     */
    click({
      checkYn,
      receiptType,
      dropdownOption,
      maskedInputValue,
      inputEventType,
    }: CartOrderPageLog.CashReceiptCheckbox.Click) {
      return KinesisTracker.click('CART_ORDER', {
        inactive: false,
        clientEventId: 858,
        pageName: 'PAGE_NAME_CART_ORDER',
        object: 'cashReceiptCheckbox',
        objectContainer: 'cashReceipt',
        objectType: 'OBJECT_TYPE_CHECKBOX',
        eventType: 'EVENT_TYPE_CLICK',
        checkYn,
        receiptType,
        dropdownOption,
        maskedInputValue,
        inputEventType,
      })
    },
  },

  CashReceiptRadioType: {
    /**
     * 주문페이지 - 현금 영수증 라디오 버튼 - 클릭
     *
     * txtpb
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/resources/clientlogs/order/misc/common.txtpb#L1158}
     * OrderCashReceipt
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/yanolja/clientlog/custom/order/misc.proto#L307}
     */
    click({
      checkYn,
      receiptType,
      dropdownOption,
      maskedInputValue,
      inputEventType,
    }: CartOrderPageLog.CashReceiptRadioType.Click) {
      return KinesisTracker.click('CART_ORDER', {
        inactive: false,
        clientEventId: 859,
        pageName: 'PAGE_NAME_CART_ORDER',
        object: 'cashReceiptType',
        objectContainer: 'cashReceipt',
        objectType: 'OBJECT_TYPE_RADIO',
        eventType: 'EVENT_TYPE_CLICK',
        checkYn,
        receiptType,
        dropdownOption,
        maskedInputValue,
        inputEventType,
      })
    },
  },

  CashReceiptDropdownFilter: {
    /**
     * 주문페이지 - 현금 영수증 드롭다운 - 클릭
     *
     * txtpb
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/resources/clientlogs/order/misc/common.txtpb#L1171}
     * OrderCashReceipt
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/yanolja/clientlog/custom/order/misc.proto#L307}
     */
    click({
      checkYn,
      receiptType,
      dropdownOption,
      maskedInputValue,
      inputEventType,
    }: CartOrderPageLog.CashReceiptDropdownFilter.Click) {
      return KinesisTracker.click('CART_ORDER', {
        inactive: false,
        clientEventId: 860,
        pageName: 'PAGE_NAME_CART_ORDER',
        object: 'cashReceiptDropdown',
        objectContainer: 'cashReceipt',
        objectType: 'OBJECT_TYPE_DROPDOWN_FILTER',
        eventType: 'EVENT_TYPE_CLICK',
        checkYn,
        receiptType,
        dropdownOption,
        maskedInputValue,
        inputEventType,
      })
    },
  },

  CashReceiptTextFieldInput: {
    /**
     * 주문페이지 - 현금 영수증 입력 박스 - 클릭
     *
     * txtpb
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/resources/clientlogs/order/misc/common.txtpb#L1184}
     * OrderCashReceipt
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/yanolja/clientlog/custom/order/misc.proto#L307}
     */
    click({
      checkYn,
      receiptType,
      dropdownOption,
      maskedInputValue,
      inputEventType,
    }: CartOrderPageLog.CashReceiptTextFieldInput.Click) {
      return KinesisTracker.click('CART_ORDER', {
        inactive: false,
        clientEventId: 861,
        pageName: 'PAGE_NAME_CART_ORDER',
        object: 'cashReceiptInput',
        objectContainer: 'cashReceipt',
        objectType: 'OBJECT_TYPE_TEXT_FIELD',
        eventType: 'EVENT_TYPE_CLICK',
        checkYn,
        receiptType,
        dropdownOption,
        maskedInputValue,
        inputEventType,
      })
    },
  },

  CashReceiptSelectModalBottomSheetOptionName: {
    /**
     * 주문페이지 - 현금 영수증 신청 선택 모달 - 클릭
     *
     * txtpb
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/resources/clientlogs/order/misc/common.txtpb#L1197}
     * OrderCashReceiptSelectModalClick
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/yanolja/clientlog/custom/order/misc.proto#L315}
     */
    click({ optionName }: CartOrderPageLog.CashReceiptSelectModalBottomSheetOptionName.Click) {
      return KinesisTracker.click('CART_ORDER', {
        inactive: false,
        clientEventId: 862,
        pageName: 'PAGE_NAME_CART_ORDER',
        object: 'optionName',
        objectContainer: 'cashReceiptSelectModal',
        objectType: 'OBJECT_TYPE_BOTTOM_SHEET',
        eventType: 'EVENT_TYPE_CLICK',
        optionName,
      })
    },
  },

  SectionNameButtonClick: {
    /**
     * 모웹 - 주문서 - NOL머니 계좌등록 및 결제시도 -  앱 이동 bottomsheet - 클릭
     *
     * txtpb
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/resources/clientlogs/order/misc/common.txtpb#L1295}
     * NolMoneySectionClick
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/yanolja/clientlog/custom/misc.proto#L120}
     */
    click({
      pageTitle,
      sectionName,
      clickName,
      context,
    }: CartOrderPageLog.SectionNameButtonClick.Click) {
      return KinesisTracker.click('CART_ORDER', {
        inactive: false,
        clientEventId: 731,
        pageName: 'PAGE_NAME_CART_ORDER',
        object: 'clickName',
        objectContainer: 'sectionName',
        objectType: 'OBJECT_TYPE_BUTTON',
        eventType: 'EVENT_TYPE_CLICK',
        pageTitle,
        sectionName,
        clickName,
        context,
      })
    },
  },

  BottomSheetSectionName: {
    /**
     * 모웹 - 주문서 - NOL머니 계좌등록 및 결제시도 -  앱 이동 bottomsheet - 노출
     *
     * txtpb
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/resources/clientlogs/order/misc/common.txtpb#L1308}
     * NolMoneySectionImpr
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/yanolja/clientlog/custom/misc.proto#L111}
     */
    impression({
      pageTitle,
      sectionName,
      context,
    }: CartOrderPageLog.BottomSheetSectionName.Impression) {
      return KinesisTracker.impression('CART_ORDER', {
        inactive: false,
        clientEventId: 732,
        pageName: 'PAGE_NAME_CART_ORDER',
        object: 'sectionName',
        objectContainer: 'sectionName',
        objectType: 'OBJECT_TYPE_BOTTOM_SHEET',
        eventType: 'EVENT_TYPE_IMPR',
        pageTitle,
        sectionName,
        context,
      })
    },
  },

  SectionNamePopupClick: {
    /**
     * PC - 주문서 - NOL머니 계좌등록 및 결제시도 -  앱사용 팝업 - 클릭
     *
     * txtpb
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/resources/clientlogs/order/misc/common.txtpb#L1321}
     * NolMoneySectionClick
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/yanolja/clientlog/custom/misc.proto#L120}
     */
    click({
      pageTitle,
      sectionName,
      clickName,
      context,
    }: CartOrderPageLog.SectionNamePopupClick.Click) {
      return KinesisTracker.click('CART_ORDER', {
        inactive: false,
        clientEventId: 733,
        pageName: 'PAGE_NAME_CART_ORDER',
        object: 'clickName',
        objectContainer: 'sectionName',
        objectType: 'OBJECT_TYPE_POPUP',
        eventType: 'EVENT_TYPE_CLICK',
        pageTitle,
        sectionName,
        clickName,
        context,
      })
    },
  },

  PopupSectionName: {
    /**
     * PC - 주문서 - NOL머니 계좌등록 및 결제시도 -  앱사용 팝업 - 노출
     *
     * txtpb
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/resources/clientlogs/order/misc/common.txtpb#L1334}
     * NolMoneySectionImpr
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/yanolja/clientlog/custom/misc.proto#L111}
     */
    impression({ pageTitle, sectionName, context }: CartOrderPageLog.PopupSectionName.Impression) {
      return KinesisTracker.impression('CART_ORDER', {
        inactive: false,
        clientEventId: 734,
        pageName: 'PAGE_NAME_CART_ORDER',
        object: 'sectionName',
        objectContainer: 'sectionName',
        objectType: 'OBJECT_TYPE_POPUP',
        eventType: 'EVENT_TYPE_IMPR',
        pageTitle,
        sectionName,
        context,
      })
    },
  },

  BottomSheetSectionName1135: {
    /**
     * 주문서 - NOL머니 새로/이어서 등록하기 -  노출 - 바텀시트
     * NOL머니 계좌등록 이후 확인 가능
     *
     * txtpb
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/resources/clientlogs/order/misc/common.txtpb#L1348}
     * OrderSectionImpr
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/yanolja/clientlog/custom/misc.proto#L184}
     */
    impression({ sectionName, context }: CartOrderPageLog.BottomSheetSectionName1135.Impression) {
      return KinesisTracker.impression('CART_ORDER', {
        inactive: false,
        clientEventId: 1135,
        pageName: 'PAGE_NAME_CART_ORDER',
        object: 'sectionName',
        objectContainer: 'sectionName',
        objectType: 'OBJECT_TYPE_BOTTOM_SHEET',
        eventType: 'EVENT_TYPE_IMPR',
        sectionName,
        context,
      })
    },
  },

  SectionNameButtonClick1136: {
    /**
     * 주문서 - NOL머니 새로/이어서 등록하기 -  클릭 - 바텀시트
     * NOL머니 계좌등록 이후 확인 가능
     *
     * txtpb
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/resources/clientlogs/order/misc/common.txtpb#L1362}
     * OrderSectionClick
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/yanolja/clientlog/custom/misc.proto#L192}
     */
    click({ sectionName, clickName, context }: CartOrderPageLog.SectionNameButtonClick1136.Click) {
      return KinesisTracker.click('CART_ORDER', {
        inactive: false,
        clientEventId: 1136,
        pageName: 'PAGE_NAME_CART_ORDER',
        object: 'clickName',
        objectContainer: 'sectionName',
        objectType: 'OBJECT_TYPE_BUTTON',
        eventType: 'EVENT_TYPE_CLICK',
        sectionName,
        clickName,
        context,
      })
    },
  },

  PopupSectionName743: {
    /**
     * 주문 - 3분 이내 동일결제금액 confirm 팝업 - 노출
     *
     * txtpb
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/resources/clientlogs/order/misc/common.txtpb#L1403}
     * OrderSectionImpr
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/yanolja/clientlog/custom/misc.proto#L184}
     */
    impression({ sectionName, context }: CartOrderPageLog.PopupSectionName743.Impression) {
      return KinesisTracker.impression('CART_ORDER', {
        inactive: false,
        clientEventId: 743,
        pageName: 'PAGE_NAME_CART_ORDER',
        object: 'sectionName',
        objectContainer: 'sectionName',
        objectType: 'OBJECT_TYPE_POPUP',
        eventType: 'EVENT_TYPE_IMPR',
        sectionName,
        context,
      })
    },
  },

  SectionNamePopupClick744: {
    /**
     * 주문 - 3분 이내 동일결제금액 confirm 팝업 - 클릭
     * ################################### 주문 취소 (PAGE_NAME_CART_ORDER_CANCEL) 로그 START ####################################
     *
     * txtpb
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/resources/clientlogs/order/misc/common.txtpb#L1416}
     * OrderSectionClick
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/yanolja/clientlog/custom/misc.proto#L192}
     */
    click({ sectionName, clickName, context }: CartOrderPageLog.SectionNamePopupClick744.Click) {
      return KinesisTracker.click('CART_ORDER', {
        inactive: false,
        clientEventId: 744,
        pageName: 'PAGE_NAME_CART_ORDER',
        object: 'clickName',
        objectContainer: 'sectionName',
        objectType: 'OBJECT_TYPE_POPUP',
        eventType: 'EVENT_TYPE_CLICK',
        sectionName,
        clickName,
        context,
      })
    },
  },
}

/**
 * 자동생성된 로그 전송 타입
 */
export namespace CartOrderPageLog {
  export namespace FullScreenDialogTitle {
    /**
        * https://screen.yanolja.in/tAmZwJHG3rX18vfJ
cusomjson 영역에 이미 정의했는데, 이것을 빼내어 표현해주실 수 있나요?
100% 전환 이후 inactive 처리 예정
        */
    export interface Impression {
      /*주문페이지에서 풀스크린다이아로그 objecttype에서 획득하는 데이터 schema 목적.
1. 정보(상태) - 풀스크린다이아로그 타이틀은? eg.쿠폰할인(https://screen.yanolja.in/oQNUAX371wHGS8Ky)*/
      fullScreenDialogTitle: string
      productOptions: CartOrderProductOptions
      /*3. 클릭 - 최대할인혜택을 클릭 시 opt-in-out을 표현하기 위해서. 클릭시 발생하므로 optional로 정의*/
      checkyn?: string
      /*4. 클릭 - 클릭되는 버튼에 쓰인 내용 eg.일반쿠폰, 더하기구폰1, 더하기구폰2
예시 스샷 : https://screen.yanolja.in/Xg1lE4MAjbkdtOtV*/
      fullScreenDialogClickName?: string
      /*추가 주문 CartOrderPage 유무 &#39;y&#39; 일 경우, 추가 주문 페이지를 의미함.
ex) add_order_page_yn = &#39;Y&#39; OR add_order_page_yn = &#39;N&#39;*/
      addOrderPageYn: string
    }
  }
  export namespace FullScreenDialogTitleCheckboxMaxDiscountBtn {
    /**
        * https://screen.yanolja.in/4ZoUfFS6F9LUMWTf
앞서 노출에도 남겼지만, objectcontainer를 채우는 것은 현 클라이언트 로그에는 개별 action마다 transactionkey가 없기 때문에
분석시 timestamp를 비롯하여 pair를 맞추기 위한 것.
100% 전환 이후 inactive 처리 예정
        */
    export interface Click {
      /*주문페이지에서 풀스크린다이아로그 objecttype에서 획득하는 데이터 schema 목적.
1. 정보(상태) - 풀스크린다이아로그 타이틀은? eg.쿠폰할인(https://screen.yanolja.in/oQNUAX371wHGS8Ky)*/
      fullScreenDialogTitle: string
      productOptions: CartOrderProductOptions
      /*3. 클릭 - 최대할인혜택을 클릭 시 opt-in-out을 표현하기 위해서. 클릭시 발생하므로 optional로 정의*/
      checkyn?: string
      /*4. 클릭 - 클릭되는 버튼에 쓰인 내용 eg.일반쿠폰, 더하기구폰1, 더하기구폰2
예시 스샷 : https://screen.yanolja.in/Xg1lE4MAjbkdtOtV*/
      fullScreenDialogClickName?: string
      /*추가 주문 CartOrderPage 유무 &#39;y&#39; 일 경우, 추가 주문 페이지를 의미함.
ex) add_order_page_yn = &#39;Y&#39; OR add_order_page_yn = &#39;N&#39;*/
      addOrderPageYn: string
    }
  }
  export namespace FullScreenDialogTitleButtonClickName {
    /**
        * https://screen.yanolja.in/Xg1lE4MAjbkdtOtV
cusomjson에 정의되어 있는데 편의상 빼내어 표현했음.
100% 전환 이후 inactive 처리 예정
        */
    export interface Click {
      /*주문페이지에서 풀스크린다이아로그 objecttype에서 획득하는 데이터 schema 목적.
1. 정보(상태) - 풀스크린다이아로그 타이틀은? eg.쿠폰할인(https://screen.yanolja.in/oQNUAX371wHGS8Ky)*/
      fullScreenDialogTitle: string
      productOptions: CartOrderProductOptions
      /*3. 클릭 - 최대할인혜택을 클릭 시 opt-in-out을 표현하기 위해서. 클릭시 발생하므로 optional로 정의*/
      checkyn?: string
      /*4. 클릭 - 클릭되는 버튼에 쓰인 내용 eg.일반쿠폰, 더하기구폰1, 더하기구폰2
예시 스샷 : https://screen.yanolja.in/Xg1lE4MAjbkdtOtV*/
      fullScreenDialogClickName?: string
      /*추가 주문 CartOrderPage 유무 &#39;y&#39; 일 경우, 추가 주문 페이지를 의미함.
ex) add_order_page_yn = &#39;Y&#39; OR add_order_page_yn = &#39;N&#39;*/
      addOrderPageYn: string
    }
  }
  export namespace FullScreenDialogTitleButtonCloseBtn {
    /**
        * https://screen.yanolja.in/eZD7Yc9bVIvJu5ps
100% 전환 이후 inactive 처리 예정
        */
    export interface Click {
      /*주문페이지에서 풀스크린다이아로그 objecttype에서 획득하는 데이터 schema 목적.
1. 정보(상태) - 풀스크린다이아로그 타이틀은? eg.쿠폰할인(https://screen.yanolja.in/oQNUAX371wHGS8Ky)*/
      fullScreenDialogTitle: string
      productOptions: CartOrderProductOptions
      /*3. 클릭 - 최대할인혜택을 클릭 시 opt-in-out을 표현하기 위해서. 클릭시 발생하므로 optional로 정의*/
      checkyn?: string
      /*4. 클릭 - 클릭되는 버튼에 쓰인 내용 eg.일반쿠폰, 더하기구폰1, 더하기구폰2
예시 스샷 : https://screen.yanolja.in/Xg1lE4MAjbkdtOtV*/
      fullScreenDialogClickName?: string
      /*추가 주문 CartOrderPage 유무 &#39;y&#39; 일 경우, 추가 주문 페이지를 의미함.
ex) add_order_page_yn = &#39;Y&#39; OR add_order_page_yn = &#39;N&#39;*/
      addOrderPageYn: string
    }
  }
  export namespace FullScreenDialogTitleButtonDiscountArea {
    /**
        * https://screen.yanolja.in/ZVjztwCF5LSqPJOu
100% 전환 이후 inactive 처리 예정
        */
    export interface Click {
      /*주문페이지에서 풀스크린다이아로그 objecttype에서 획득하는 데이터 schema 목적.
1. 정보(상태) - 풀스크린다이아로그 타이틀은? eg.쿠폰할인(https://screen.yanolja.in/oQNUAX371wHGS8Ky)*/
      fullScreenDialogTitle: string
      productOptions: CartOrderProductOptions
      /*3. 클릭 - 최대할인혜택을 클릭 시 opt-in-out을 표현하기 위해서. 클릭시 발생하므로 optional로 정의*/
      checkyn?: string
      /*4. 클릭 - 클릭되는 버튼에 쓰인 내용 eg.일반쿠폰, 더하기구폰1, 더하기구폰2
예시 스샷 : https://screen.yanolja.in/Xg1lE4MAjbkdtOtV*/
      fullScreenDialogClickName?: string
      /*추가 주문 CartOrderPage 유무 &#39;y&#39; 일 경우, 추가 주문 페이지를 의미함.
ex) add_order_page_yn = &#39;Y&#39; OR add_order_page_yn = &#39;N&#39;*/
      addOrderPageYn: string
    }
  }
  export namespace BottomSheetTitle {
    /**
        * https://screen.yanolja.in/SXcRkigEjxEXt8mq
100% 전환 이후 inactive 처리 예정
        */
    export interface Impression {
      /*CX 개선 스크린샷 https://screen.yanolja.in/StcEs31nT8s69q1F*/
      bottomSheetTitle: string
      couponOptions?: CouponOptions[]
      /*3. 클릭시 클릭한 버튼에 쓰여진 정보.*/
      bottomSheetClickName?: string
      /*추가 주문 CartOrderPage 유무 &#39;y&#39; 일 경우, 추가 주문 페이지를 의미함.
ex) add_order_page_yn = &#39;Y&#39; OR add_order_page_yn = &#39;N&#39;*/
      addOrderPageYn: string
    }
  }
  export namespace BottomSheetTitleButtonCloseBtn {
    /**
        * https://screen.yanolja.in/w11z0JqtROmkhrL4
100% 전환 이후 inactive 처리 예정
        */
    export interface Click {
      /*CX 개선 스크린샷 https://screen.yanolja.in/StcEs31nT8s69q1F*/
      bottomSheetTitle: string
      couponOptions?: CouponOptions[]
      /*3. 클릭시 클릭한 버튼에 쓰여진 정보.*/
      bottomSheetClickName?: string
      /*추가 주문 CartOrderPage 유무 &#39;y&#39; 일 경우, 추가 주문 페이지를 의미함.
ex) add_order_page_yn = &#39;Y&#39; OR add_order_page_yn = &#39;N&#39;*/
      addOrderPageYn: string
    }
  }
  export namespace BottomSheetTitleButtonClickName {
    /**
        * https://screen.yanolja.in/J4rzLkqcN8Tlbwkp
100% 전환 이후 inactive 처리 예정
        */
    export interface Click {
      /*CX 개선 스크린샷 https://screen.yanolja.in/StcEs31nT8s69q1F*/
      bottomSheetTitle: string
      couponOptions?: CouponOptions[]
      /*3. 클릭시 클릭한 버튼에 쓰여진 정보.*/
      bottomSheetClickName?: string
      /*추가 주문 CartOrderPage 유무 &#39;y&#39; 일 경우, 추가 주문 페이지를 의미함.
ex) add_order_page_yn = &#39;Y&#39; OR add_order_page_yn = &#39;N&#39;*/
      addOrderPageYn: string
    }
  }
  export namespace BottomSheetTitleButtonCouponId {
    /**
     * https://screen.yanolja.in/qk94A2J5T3pKw7eB
     */
    export interface Click {
      /*CX 개선 스크린샷 https://screen.yanolja.in/StcEs31nT8s69q1F*/
      bottomSheetTitle: string
      couponOptions?: CouponOptions[]
      /*3. 클릭시 클릭한 버튼에 쓰여진 정보.*/
      bottomSheetClickName?: string
      /*추가 주문 CartOrderPage 유무 &#39;y&#39; 일 경우, 추가 주문 페이지를 의미함.
ex) add_order_page_yn = &#39;Y&#39; OR add_order_page_yn = &#39;N&#39;*/
      addOrderPageYn: string
      couponId: string
    }
  }
  export namespace CartOrderViewInfo {
    /**
        * 기존 로그 + add_order_page_yn 만 추가
스크린 : https://screen.yanolja.in/9uSA5U32D8lwcclZ
100% 전환 이후 inactive 처리 예정 - 혜택정보 텍스트 클릭 변경
        */
    export interface View {
      /*로그인 유무 ex Y,N*/
      isLogin: string
      /*주문 상품 정보*/
      productOptions: CartOrderProductOptions
      /*가능한 쿠폰 건수*/
      availableCouponCount: string
      /*주문창에서 왔는지 유무*/
      fromCartYn: string
      /*추가 주문 CartOrderPage 유무 &#39;Y&#39; 일 경우, 추가 주문 페이지를 의미함.*/
      addOrderPageYn: string
    }
  }
  export namespace NolCardBanner {
    /**
        * 기존 로그 수정
스크린 : https://screen.yanolja.in/ZdG7I2EnQdi30ifA
100% 전환 이후 inactive 처리 예정 - 혜택정보 텍스트 클릭 변경
        */
    export interface Impression {
      /*해시 주문 id - 통합주문 번호를 의미*/
      hashOrderId: string
      /*nol카드 가입유도 배너 구분 ex) nolCoupon | nolFirstPay | nolPromotion*/
      nolCard?: string
      /*지급 방법 ex) TOSS*/
      paymentMethod?: string
      /*추가 주문 CartOrderPage 유무 &#39;Y&#39; 일 경우, 추가 주문 페이지를 의미함.*/
      addOrderPageYn: string
    }

    /**
        * 기존 로그 수정
스크린 : https://screen.yanolja.in/ZdG7I2EnQdi30ifA
        */
    export interface Click {
      /*해시 주문 id - 통합주문 번호를 의미*/
      hashOrderId: string
      /*nol카드 가입유도 배너 구분 ex) nolCoupon | nolFirstPay | nolPromotion*/
      nolCard?: string
      /*지급 방법 ex) TOSS*/
      paymentMethod?: string
      /*추가 주문 CartOrderPage 유무 &#39;Y&#39; 일 경우, 추가 주문 페이지를 의미함.*/
      addOrderPageYn: string
    }
  }
  export namespace PaymentButtonMethod {
    /**
        * 기존 로그 수정
스크린 : https://screen.yanolja.in/TyxEcbSMfBcq3POi.png
100% 전환 이후 inactive 처리 예정
        */
    export interface Click {
      /*해시 주문 id - 통합주문 번호를 의미*/
      hashOrderId: string
      /*nol카드 가입유도 배너 구분 ex) nolCoupon | nolFirstPay | nolPromotion*/
      nolCard?: string
      /*지급 방법 ex) TOSS*/
      paymentMethod?: string
      /*추가 주문 CartOrderPage 유무 &#39;Y&#39; 일 경우, 추가 주문 페이지를 의미함.*/
      addOrderPageYn: string
    }
  }
  export namespace PaymentButtonBtn {
    /**
        * 기존 로그 수정
스크린 : https://screen.yanolja.in/99kFQ7BzDY2cga2Z
        */
    export interface Click {
      /*해시 주문 id - 통합주문 번호를 의미*/
      hashOrderId: string
      /*nol카드 가입유도 배너 구분 ex) nolCoupon | nolFirstPay | nolPromotion*/
      nolCard?: string
      /*지급 방법 ex) TOSS*/
      paymentMethod?: string
      /*추가 주문 CartOrderPage 유무 &#39;Y&#39; 일 경우, 추가 주문 페이지를 의미함.*/
      addOrderPageYn: string
    }
  }
  export namespace PopupOrderFailed {
    /**
     * 스크린 : https://screen.yanolja.in/w834gUMGtlV8x4jE
     */
    export interface Impression {
      /*해시 주문 id - 통합주문 번호를 의미*/
      hashOrderId: string
      /*팝업타이틀 ex) 입장권 수량에 맞게 화담채와 모노레일도 취소해 주세요.*/
      popupTitle: string
      /*추가 주문 CartOrderPage 유무 &#39;Y&#39; 일 경우, 추가 주문 페이지를 의미함.*/
      addOrderPageYn: string
    }
  }
  export namespace BannerTimer {
    /**
     * 스크린 : https://screen.yanolja.in/r9ygsYfrFl0qJPAV
     */
    export interface Impression {
      /*해시 주문 id - 통합주문 번호를 의미*/
      hashOrderId: string
      /*추가 주문 CartOrderPage 유무 &#39;Y&#39; 일 경우, 추가 주문 페이지를 의미함.*/
      addOrderPageYn: string
    }
  }
  export namespace PointTypeCheckboxSave {
    /**
     * 스크린 : https://screen.yanolja.in/20ViU4ponEx0B2rE
     */
    export interface Impression {
      /*해시 주문 id - 통합주문 번호를 의미*/
      hashOrderId: string
      /*추가 주문 CartOrderPage 유무 &#39;Y&#39; 일 경우, 추가 주문 페이지를 의미함.*/
      addOrderPageYn: string
      /*체크 여부를 의미함.*/
      checkYn?: boolean
      /*클릭에 쓰인 내용. eg.연결하기, 전액사용*/
      clickName?: string
      /*놀 포인트, CJ포인트 등등*/
      pointType?: string
    }
  }
  export namespace PointTypeCheckboxCheckYn {
    /**
     * 스크린 : https://screen.yanolja.in/20ViU4ponEx0B2rE
     */
    export interface Click {
      /*해시 주문 id - 통합주문 번호를 의미*/
      hashOrderId: string
      /*추가 주문 CartOrderPage 유무 &#39;Y&#39; 일 경우, 추가 주문 페이지를 의미함.*/
      addOrderPageYn: string
      /*체크 여부를 의미함.*/
      checkYn?: boolean
      /*클릭에 쓰인 내용. eg.연결하기, 전액사용*/
      clickName?: string
      /*놀 포인트, CJ포인트 등등*/
      pointType?: string
    }
  }
  export namespace PointTypeButtonClickName {
    /**
        * 스크린 : https://screen.yanolja.in/als3CqJ82mn7Ae1A
################################### CartOrder CX 개선 이후 추가 로그 ####################################
        */
    export interface Click {
      /*해시 주문 id - 통합주문 번호를 의미*/
      hashOrderId: string
      /*추가 주문 CartOrderPage 유무 &#39;Y&#39; 일 경우, 추가 주문 페이지를 의미함.*/
      addOrderPageYn: string
      /*체크 여부를 의미함.*/
      checkYn?: boolean
      /*클릭에 쓰인 내용. eg.연결하기, 전액사용*/
      clickName?: string
      /*놀 포인트, CJ포인트 등등*/
      pointType?: string
    }
  }
  export namespace ButtonBackward {
    /**
     * 구 로그번호 : 없음(object = backwardBtn)
     */
    export interface Click {}
  }
  export namespace HeaderTextLogin {
    /**
     * 구 로그번호 : 없음(object = topLoginBtn)
     */
    export interface Click {}
  }
  export namespace ButtonLogin {
    /**
     * 구 로그번호 : 없음(object = loginBtn)
     */
    export interface Click {}
  }
  export namespace BannerFreeCancelInfo {
    /**
     * 국내숙소 예외취소 정책 : 취소수수료가 부과되는 경우 예약 완료 후 일정 시간 이내에 무료로 취소할 수 있는 상위 플랫폼 정책
     */
    export interface Impression {
      productOptions: CartOrderProductOptions
    }
  }
  export namespace ButtonFreeCancelInfo {
    /**
     * 국내숙소 예외취소 정책 : 취소수수료가 부과되는 경우 예약 완료 후 일정 시간 이내에 무료로 취소할 수 있는 상위 플랫폼 정책
     */
    export interface Click {
      productOptions: CartOrderProductOptions
    }
  }
  export namespace TextChangePhone {
    /**
     * 구 로그번호 : 없음(object = changePhoneBtn)
     */
    export interface Click {}
  }
  export namespace ButtonVerifyIdentity {
    /**
     */
    export interface Click {}
  }
  export namespace CompletedVerifyIdentity {
    /**
     */
    export interface Bg {}
  }
  export namespace DiscountSectionButton {
    /**
     * 구 로그번호 : 없음(object = discountBtn)
     */
    export interface Click {
      productOptions: CartOrderProductOptions
      addOrderPageYn: string
      /*클릭 배너에 표기되는 내용. (e.g -9,999원 쿠폰 할인)*/
      couponBoxTitle: string
    }
  }
  export namespace DiscountSectionCheckboxMax {
    /**
     * 구 로그번호 : 없음(object = maxDiscountBtn)
     */
    export interface Click {
      /*체크박스 체크 y, 체크 해제 n : 소문자로 작성*/
      checkYn: string
    }
  }
  export namespace DiscountSelectionRadioClickName {
    /**
     */
    export interface Click {
      productOptions: CartOrderProductOptions
      addOrderPageYn: string
      clickName: CartOrderDiscountSelectionType
      orderDiscounts: CartOrderDiscountInfo
    }
  }
  export namespace DiscountSelectionCheckboxMax {
    /**
     * 구 로그번호 : 103
     */
    export interface Click {
      /*https://screen.yanolja.in/Wx13451vrCjFKoEL*/
      productOptions: CartOrderProductOptions
      /*체크박스 체크 y, 체크 해제 n : 소문자로 작성*/
      checkYn: string
      addOrderPageYn: string
    }
  }
  export namespace DiscountSelectionDropdownFilterClickName {
    /**
     * 구 로그번호 : 104
     */
    export interface Click {
      productOptions: CartOrderProductOptions
      /*eg.일반쿠폰, 더하기쿠폰1, 더하기쿠폰2  https://screen.yanolja.in/DouTEar8ONEiX8jx*/
      clickName: string
      addOrderPageYn: string
    }
  }
  export namespace DiscountSelectionButtonClose {
    /**
     * 구 로그번호 : 105
     */
    export interface Click {
      productOptions: CartOrderProductOptions
      addOrderPageYn: string
      orderDiscounts: CartOrderDiscountInfo
    }
  }
  export namespace DiscountSelectionButtonApply {
    /**
     * 구 로그번호 : 106
     */
    export interface Click {
      productOptions: CartOrderProductOptions
      addOrderPageYn: string
      orderDiscounts: CartOrderDiscountInfo
    }
  }
  export namespace BottomSheetCouponSelection {
    /**
     * 구 로그번호 : 107
     */
    export interface Impression {
      /*노출시 전체 쿠폰 리스트 나오도록
노출된 것이 아에 없을 경우 null 처리로!*/
      couponOptions?: CouponSelectionOptions[]
      addOrderPageYn: string
    }
  }
  export namespace CouponSelectionButtonClickName {
    /**
     * 구 로그번호 : 109,110
     */
    export interface Click {
      /*클릭한 쿠폰 정보, 적용안함은 null로*/
      couponOptions?: CouponSelectionOptions[]
      /*클릭시 클릭한 버튼에 쓰여진 정보(스크린샷 참고 https://screen.yanolja.in/8KVCgceTvaeCAg5T)*/
      clickName?: string
      /*추가 주문 CartOrderPage 유무 &#39;y&#39; 일 경우, 추가 주문 페이지를 의미함.
ex) add_order_page_yn = &#39;Y&#39; OR add_order_page_yn = &#39;N&#39;*/
      addOrderPageYn: string
    }
  }
  export namespace CouponSelectionButtonApply {
    /**
     */
    export interface Click {
      /*클릭한 쿠폰 정보, 적용안함은 null로*/
      couponOptions?: CouponSelectionOptions[]
      /*클릭시 클릭한 버튼에 쓰여진 정보(스크린샷 참고 https://screen.yanolja.in/8KVCgceTvaeCAg5T)*/
      clickName?: string
      /*추가 주문 CartOrderPage 유무 &#39;y&#39; 일 경우, 추가 주문 페이지를 의미함.
ex) add_order_page_yn = &#39;Y&#39; OR add_order_page_yn = &#39;N&#39;*/
      addOrderPageYn: string
    }
  }
  export namespace ButtonPayment {
    /**
     * 구 로그번호 : 424
     */
    export interface Click {
      /*추가 주문 CartOrderPage 유무 &#39;Y&#39; 일 경우, 추가 주문 페이지를 의미함.*/
      addOrderPageYn: string
      /*예: &#34;KAKAOPAY&#34;*/
      pgType: string
      productOptions: CartOrderProductOptions
      /*3. 결제 금액 및 요약 정보*/
      orderAmount: string
      /*포인트 사용액, 이전 야놀자포인트로 제외(놀포인트로 남음)*/
      pointAmount: string
      /*패키지 할인액*/
      packageDiscountAmount: string
      /*최종 실 결제 금액*/
      pgAmount: string
      /*쿠폰 할인액 합계*/
      couponAmount: string
      /*놀포인트 사용액*/
      nolPointAmount: string
      /*https://screen.yanolja.in/4yXqwxDZiD2DVnET*/
      isMaxDiscountApplied?: boolean
      /*예약자 정보와 같음 체크박스 여부*/
      isSameAsBooker?: boolean
      /*4. 구매 적립 예정 놀포인트
예시 스샷 : https://screen.yanolja.in/nsrMZ6PvxGWsn1qc
e.g. {memberClass:&#34;PLATINUM_CLASS&#34;, expectedRewardAmount:1500}*/
      rewardBenefit?: MemberRewardBenefit
    }
  }
  export namespace BenefitInfoTextType {
    /**
     * 구 로그번호 : 421
     */
    export interface Impression {
      /*주문서 https://screen.yanolja.in/saOSE9SnSVT6yezL
예약완료 https://screen.yanolja.in/IT4oYygmkppAM7j1*/
      benefitType: string
      /*가입유도 배너 구분 ex) nolCoupon | nolFirstPay | nolPromotion*/
      benefitSubType: string
    }

    /**
     * 구 로그번호 : 422
     */
    export interface Click {
      /*주문서 https://screen.yanolja.in/saOSE9SnSVT6yezL
예약완료 https://screen.yanolja.in/IT4oYygmkppAM7j1*/
      benefitType: string
      /*가입유도 배너 구분 ex) nolCoupon | nolFirstPay | nolPromotion*/
      benefitSubType: string
    }
  }
  export namespace DiscountSectionTextBenefitType {
    /**
        * NOL카드 미발급자에 한해 노출
구 로그번호 : 없음(object = nolCoupon)
        */
    export interface Impression {
      /*주문서 https://screen.yanolja.in/saOSE9SnSVT6yezL
예약완료 https://screen.yanolja.in/IT4oYygmkppAM7j1*/
      benefitType: string
      /*가입유도 배너 구분 ex) nolCoupon | nolFirstPay | nolPromotion*/
      benefitSubType: string
    }

    /**
     * 구 로그번호 : 없음(object = nolCoupon)
     */
    export interface Click {
      /*주문서 https://screen.yanolja.in/saOSE9SnSVT6yezL
예약완료 https://screen.yanolja.in/IT4oYygmkppAM7j1*/
      benefitType: string
      /*가입유도 배너 구분 ex) nolCoupon | nolFirstPay | nolPromotion*/
      benefitSubType: string
    }
  }
  export namespace ProductInfoButtonFreeCancel {
    /**
     */
    export interface Click {
      productCategory: ProductCategory
    }
  }
  export namespace BottomSheetReservationConfirm {
    /**
     */
    export interface Impression {
      productOptions: CartOrderProductOptions
    }
  }
  export namespace ReservationConfirmButtonClickName {
    /**
     */
    export interface Click {
      /*https://screen.yanolja.in/lYFmuA3Nb7vsvNUF*/
      productOptions: CartOrderProductOptions
      /*버튼에 적힌 문구*/
      clickName: string
    }
  }
  export namespace FullScreenDialogError {
    /**
     */
    export interface Impression {
      /*에러 문구 https://screen.yanolja.in/BJ9LbCRilbf0sdez*/
      errorTitle: string
      /*클릭로그에 대해서만 클릭 문구 https://screen.yanolja.in/NUBT34ro34mhAFW0*/
      clickName?: string
    }
  }
  export namespace ErrorButtonClickName {
    /**
     */
    export interface Click {
      /*에러 문구 https://screen.yanolja.in/BJ9LbCRilbf0sdez*/
      errorTitle: string
      /*클릭로그에 대해서만 클릭 문구 https://screen.yanolja.in/NUBT34ro34mhAFW0*/
      clickName?: string
    }
  }
  export namespace TermsSectionCheckboxClickName {
    /**
        * ################################### 주문 완료(CART_ORDER_COMPLETE) 로그 START ####################################
100% 전환 이후 inactive 처리 예정
        */
    export interface Click {
      isLogin: boolean
      /*클릭한 약관 항목*/
      clickName: OrderTermsType
      /*클릭 후 해당 항목 체크 여부 (true: 체크, false: 해제)*/
      isChecked: boolean
    }
  }
  export namespace PaymentNolMoneyButtonClickName {
    /**
     * 스크린 : https://screen.yanolja.in/HiNEfONERvx1KEhA
     */
    export interface Click {
      /*추가 주문 CartOrderPage 유무 &#39;Y&#39; 일 경우, 추가 주문 페이지를 의미함.*/
      addOrderPageYn: string
      /*click_name : https://screen.yanolja.in/HiNEfONERvx1KEhA eg. 로그인, 충전계좌 등록 - 놀머니 가입, 계좌 등록*/
      clickName: string
      /*놀머니 가입 여부*/
      nolmoneyRegisterYn: string
      /*놀머니 계좌 연결 상태*/
      accountRegistrationYn: string
    }
  }
  export namespace PaymentNolMoneyPopupButtonClickName {
    /**
     * 스크린샷 : https://screen.yanolja.in/Z7IbK9Eb0oOsWk69
     */
    export interface Click {
      /*click_name : https://screen.yanolja.in/Z7IbK9Eb0oOsWk69 eg.계좌등록하기*/
      clickName: string
      /*놀머니 가입 여부*/
      nolmoneyRegisterYn: string
      /*놀머니 계좌 연결 상태*/
      accountRegistrationYn: string
    }
  }
  export namespace NolMoneyCertifyBottomSheetButton {
    /**
        * 화면 : https://screen.yanolja.in/NLsGOJuXf3Kr7lZH
######################### 현금 영수증 로그 ##########################
        */
    export interface Click {}
  }
  export namespace WidgetCashReceipt {
    /**
     */
    export interface Impression {
      /*체크박스 선택 여부*/
      checkYn: boolean
      /*현금영수증 유형 - 라디오 타입 선택*/
      receiptType?: CashReceiptType
      /*현금영수증 입력 방식 옵션 - 드롭다운에서 선택한 옵션*/
      dropdownOption?: CashReceiptOption
      /*사용자가 입력한 값 (개인정보이므로 모든 숫자는 마스킹 처리되어야 함 ex. xxx-xxxx-xxxx)*/
      maskedInputValue?: string
      /*입력 박스 이벤트 타입 (클릭/포커스아웃/삭제/입력값 변경)*/
      inputEventType?: CashReceiptInputEventType
    }
  }
  export namespace CashReceiptCheckbox {
    /**
     */
    export interface Click {
      /*체크박스 선택 여부*/
      checkYn: boolean
      /*현금영수증 유형 - 라디오 타입 선택*/
      receiptType?: CashReceiptType
      /*현금영수증 입력 방식 옵션 - 드롭다운에서 선택한 옵션*/
      dropdownOption?: CashReceiptOption
      /*사용자가 입력한 값 (개인정보이므로 모든 숫자는 마스킹 처리되어야 함 ex. xxx-xxxx-xxxx)*/
      maskedInputValue?: string
      /*입력 박스 이벤트 타입 (클릭/포커스아웃/삭제/입력값 변경)*/
      inputEventType?: CashReceiptInputEventType
    }
  }
  export namespace CashReceiptRadioType {
    /**
     */
    export interface Click {
      /*체크박스 선택 여부*/
      checkYn: boolean
      /*현금영수증 유형 - 라디오 타입 선택*/
      receiptType?: CashReceiptType
      /*현금영수증 입력 방식 옵션 - 드롭다운에서 선택한 옵션*/
      dropdownOption?: CashReceiptOption
      /*사용자가 입력한 값 (개인정보이므로 모든 숫자는 마스킹 처리되어야 함 ex. xxx-xxxx-xxxx)*/
      maskedInputValue?: string
      /*입력 박스 이벤트 타입 (클릭/포커스아웃/삭제/입력값 변경)*/
      inputEventType?: CashReceiptInputEventType
    }
  }
  export namespace CashReceiptDropdownFilter {
    /**
     */
    export interface Click {
      /*체크박스 선택 여부*/
      checkYn: boolean
      /*현금영수증 유형 - 라디오 타입 선택*/
      receiptType?: CashReceiptType
      /*현금영수증 입력 방식 옵션 - 드롭다운에서 선택한 옵션*/
      dropdownOption?: CashReceiptOption
      /*사용자가 입력한 값 (개인정보이므로 모든 숫자는 마스킹 처리되어야 함 ex. xxx-xxxx-xxxx)*/
      maskedInputValue?: string
      /*입력 박스 이벤트 타입 (클릭/포커스아웃/삭제/입력값 변경)*/
      inputEventType?: CashReceiptInputEventType
    }
  }
  export namespace CashReceiptTextFieldInput {
    /**
     */
    export interface Click {
      /*체크박스 선택 여부*/
      checkYn: boolean
      /*현금영수증 유형 - 라디오 타입 선택*/
      receiptType?: CashReceiptType
      /*현금영수증 입력 방식 옵션 - 드롭다운에서 선택한 옵션*/
      dropdownOption?: CashReceiptOption
      /*사용자가 입력한 값 (개인정보이므로 모든 숫자는 마스킹 처리되어야 함 ex. xxx-xxxx-xxxx)*/
      maskedInputValue?: string
      /*입력 박스 이벤트 타입 (클릭/포커스아웃/삭제/입력값 변경)*/
      inputEventType?: CashReceiptInputEventType
    }
  }
  export namespace CashReceiptSelectModalBottomSheetOptionName {
    /**
     */
    export interface Click {
      /*모달에서 선택한 항목 옵션*/
      optionName: CashReceiptOption
    }
  }
  export namespace SectionNameButtonClick {
    /**
     */
    export interface Click {
      /*놀머니브릿지페이지 바텀시트 클릭 https://screen.yanolja.in/sNdBq0nFyEVCmXEv
모웹 앱안내 바텀시트 클릭 https://screen.yanolja.in/h8a3KqYEY5Q0r8rH
PC 앱안내 팝업 클릭 https://screen.yanolja.in/F07bZyPRhG1UD49L*/
      pageTitle: string
      sectionName: string
      /*버튼에 적혀있는 내용  eg.이어서 등록하기*/
      clickName: string
      /*서비스/디바이스 구분 정보 (놀 결제 화면에서 발생 시에만 설정)*/
      context?: PaymentLogContext
    }
  }
  export namespace BottomSheetSectionName {
    /**
     */
    export interface Impression {
      /*놀머니브릿지페이지 바텀시트 노출 https://screen.yanolja.in/sNdBq0nFyEVCmXEv
놀머니 모웹 안내 바텀시트 노출 https://screen.yanolja.in/h8a3KqYEY5Q0r8rH
PC 앱안내 팝업 클릭 https://screen.yanolja.in/F07bZyPRhG1UD49L*/
      pageTitle: string
      sectionName: string
      /*서비스/디바이스 구분 정보 (놀 결제 화면에서 발생 시에만 설정)*/
      context?: PaymentLogContext
    }
  }
  export namespace SectionNamePopupClick {
    /**
     */
    export interface Click {
      /*놀머니브릿지페이지 바텀시트 클릭 https://screen.yanolja.in/sNdBq0nFyEVCmXEv
모웹 앱안내 바텀시트 클릭 https://screen.yanolja.in/h8a3KqYEY5Q0r8rH
PC 앱안내 팝업 클릭 https://screen.yanolja.in/F07bZyPRhG1UD49L*/
      pageTitle: string
      sectionName: string
      /*버튼에 적혀있는 내용  eg.이어서 등록하기*/
      clickName: string
      /*서비스/디바이스 구분 정보 (놀 결제 화면에서 발생 시에만 설정)*/
      context?: PaymentLogContext
    }
  }
  export namespace PopupSectionName {
    /**
     */
    export interface Impression {
      /*놀머니브릿지페이지 바텀시트 노출 https://screen.yanolja.in/sNdBq0nFyEVCmXEv
놀머니 모웹 안내 바텀시트 노출 https://screen.yanolja.in/h8a3KqYEY5Q0r8rH
PC 앱안내 팝업 클릭 https://screen.yanolja.in/F07bZyPRhG1UD49L*/
      pageTitle: string
      sectionName: string
      /*서비스/디바이스 구분 정보 (놀 결제 화면에서 발생 시에만 설정)*/
      context?: PaymentLogContext
    }
  }
  export namespace BottomSheetSectionName1135 {
    /**
     * NOL머니 계좌등록 이후 확인 가능
     */
    export interface Impression {
      /*주문 - 3분 이내 동일결제금액 confirm 팝업 https://screen.yanolja.in/3nV5wHf3RhlOnnUe
결제 - 결제 중 화면닫기 시 confirm 팝업 https://screen.yanolja.in/LPJBP8H8CB1iOLZ5
놀머니 이어서 등록하기 바텀시트 https://screen.yanolja.in/zI1RuPgwnRnlOklT*/
      sectionName: string
      /*서비스/디바이스 구분 정보 (놀 결제 화면에서 발생 시에만 설정)*/
      context?: PaymentLogContext
    }
  }
  export namespace SectionNameButtonClick1136 {
    /**
     * NOL머니 계좌등록 이후 확인 가능
     */
    export interface Click {
      /*주문 - 3분 이내 동일결제금액 confirm 팝업 https://screen.yanolja.in/3nV5wHf3RhlOnnUe
결제 - 결제 중 화면닫기 시 confirm 팝업 https://screen.yanolja.in/LPJBP8H8CB1iOLZ5
놀머니 이어서 등록하기 바텀시트 https://screen.yanolja.in/zI1RuPgwnRnlOklT*/
      sectionName: string
      clickName: string
      /*서비스/디바이스 구분 정보 (놀 결제 화면에서 발생 시에만 설정)*/
      context?: PaymentLogContext
    }
  }
  export namespace PopupSectionName743 {
    /**
     */
    export interface Impression {
      /*주문 - 3분 이내 동일결제금액 confirm 팝업 https://screen.yanolja.in/3nV5wHf3RhlOnnUe
결제 - 결제 중 화면닫기 시 confirm 팝업 https://screen.yanolja.in/LPJBP8H8CB1iOLZ5
놀머니 이어서 등록하기 바텀시트 https://screen.yanolja.in/zI1RuPgwnRnlOklT*/
      sectionName: string
      /*서비스/디바이스 구분 정보 (놀 결제 화면에서 발생 시에만 설정)*/
      context?: PaymentLogContext
    }
  }
  export namespace SectionNamePopupClick744 {
    /**
     * ################################### 주문 취소 (PAGE_NAME_CART_ORDER_CANCEL) 로그 START ####################################
     */
    export interface Click {
      /*주문 - 3분 이내 동일결제금액 confirm 팝업 https://screen.yanolja.in/3nV5wHf3RhlOnnUe
결제 - 결제 중 화면닫기 시 confirm 팝업 https://screen.yanolja.in/LPJBP8H8CB1iOLZ5
놀머니 이어서 등록하기 바텀시트 https://screen.yanolja.in/zI1RuPgwnRnlOklT*/
      sectionName: string
      clickName: string
      /*서비스/디바이스 구분 정보 (놀 결제 화면에서 발생 시에만 설정)*/
      context?: PaymentLogContext
    }
  }
}

/**
 * PageName: CART_ORDER_COMPLETE    */
export const CartOrderCompletePageLog = {
  BannerYanoljaClass: {
    /**
        * 주문페이지 야놀자 class 배너 노출
        * 신규 로그
100% 전환 이후 inactive 처리 예정
        *
* txtpb
* @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/resources/clientlogs/order/misc/common.txtpb#L634}
                    */
    impression({}: CartOrderCompletePageLog.BannerYanoljaClass.Impression = {}) {
      return KinesisTracker.impression('CART_ORDER_COMPLETE', {
        clientEventId: 99,
        pageName: 'PAGE_NAME_CART_ORDER_COMPLETE',
        object: 'yanoljaClassBanner',
        objectType: 'OBJECT_TYPE_BANNER',
        eventType: 'EVENT_TYPE_IMPR',
      })
    },

    /**
     * 주문페이지 야놀자 class 배너 클릭
     * 신규 로그
     *
     * txtpb
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/resources/clientlogs/order/misc/common.txtpb#L646}
     */
    click({}: CartOrderCompletePageLog.BannerYanoljaClass.Click = {}) {
      return KinesisTracker.click('CART_ORDER_COMPLETE', {
        clientEventId: 101,
        pageName: 'PAGE_NAME_CART_ORDER_COMPLETE',
        object: 'yanoljaClassBanner',
        objectType: 'OBJECT_TYPE_BANNER',
        eventType: 'EVENT_TYPE_CLICK',
      })
    },
  },

  BannerTripPlan: {
    /**
     * 국내 주문완료 - 노출 - 여행일정 진입점 - 배너
     *
     * txtpb
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/resources/clientlogs/order/misc/common.txtpb#L658}
     * CartOrderCompleteTripPlan
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/yanolja/clientlog/custom/order/misc.proto#L678}
     */
    impression({
      hashOrderId,
      tripId,
      title,
      subTitle,
      isNewTrip,
    }: CartOrderCompletePageLog.BannerTripPlan.Impression) {
      return KinesisTracker.impression('CART_ORDER_COMPLETE', {
        inactive: false,
        clientEventId: 1425,
        pageName: 'PAGE_NAME_CART_ORDER_COMPLETE',
        object: 'tripPlan',
        objectType: 'OBJECT_TYPE_BANNER',
        eventType: 'EVENT_TYPE_IMPR',
        hashOrderId,
        tripId,
        title,
        subTitle,
        isNewTrip,
      })
    },

    /**
     * 국내 주문완료 - 클릭 - 여행일정 진입점 - 배너
     *
     * txtpb
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/resources/clientlogs/order/misc/common.txtpb#L670}
     * CartOrderCompleteTripPlan
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/yanolja/clientlog/custom/order/misc.proto#L678}
     */
    click({
      hashOrderId,
      tripId,
      title,
      subTitle,
      isNewTrip,
    }: CartOrderCompletePageLog.BannerTripPlan.Click) {
      return KinesisTracker.click('CART_ORDER_COMPLETE', {
        inactive: false,
        clientEventId: 1426,
        pageName: 'PAGE_NAME_CART_ORDER_COMPLETE',
        object: 'tripPlan',
        objectType: 'OBJECT_TYPE_BANNER',
        eventType: 'EVENT_TYPE_CLICK',
        hashOrderId,
        tripId,
        title,
        subTitle,
        isNewTrip,
      })
    },
  },

  FloatingButtonImprName: {
    /**
     * 국내 주문완료 - 노출 - 여행일정 진입점 - 플로팅버튼
     *
     * txtpb
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/resources/clientlogs/order/misc/common.txtpb#L682}
     * CartOrderFloatingButton
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/yanolja/clientlog/custom/order/misc.proto#L687}
     */
    impression({
      hashOrderId,
      imprName,
      clickName,
    }: CartOrderCompletePageLog.FloatingButtonImprName.Impression) {
      return KinesisTracker.impression('CART_ORDER_COMPLETE', {
        inactive: false,
        clientEventId: 1427,
        pageName: 'PAGE_NAME_CART_ORDER_COMPLETE',
        object: 'imprName',
        objectType: 'OBJECT_TYPE_FLOATING_BUTTON',
        eventType: 'EVENT_TYPE_IMPR',
        hashOrderId,
        imprName,
        clickName,
      })
    },
  },

  FloatingButtonClickName: {
    /**
     * 국내 주문완료 - 클릭 - 여행일정 진입점 - 플로팅버튼
     *
     * txtpb
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/resources/clientlogs/order/misc/common.txtpb#L694}
     * CartOrderFloatingButton
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/yanolja/clientlog/custom/order/misc.proto#L687}
     */
    click({
      hashOrderId,
      imprName,
      clickName,
    }: CartOrderCompletePageLog.FloatingButtonClickName.Click) {
      return KinesisTracker.click('CART_ORDER_COMPLETE', {
        inactive: false,
        clientEventId: 1428,
        pageName: 'PAGE_NAME_CART_ORDER_COMPLETE',
        object: 'clickName',
        objectType: 'OBJECT_TYPE_FLOATING_BUTTON',
        eventType: 'EVENT_TYPE_CLICK',
        hashOrderId,
        imprName,
        clickName,
      })
    },
  },

  OrderCompleteView: {
    /**
     * 국내 주문완료 화면 - 진입
     *
     * txtpb
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/resources/clientlogs/order/misc/common.txtpb#L706}
     * OrderCompleteView
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/yanolja/clientlog/custom/order/misc.proto#L696}
     */
    view({
      hashOrderId,
      pgType,
      pgAmount,
      orderAmount,
      couponAmount,
      pointAmount,
      nolPointAmount,
      packageDiscountAmount,
      fromCartYn,
      maxDiscountYn,
      trackCode,
      productOptions,
      rewardBenefit,
    }: CartOrderCompletePageLog.OrderCompleteView.View) {
      return KinesisTracker.view('CART_ORDER_COMPLETE', {
        inactive: false,
        clientEventId: 1562,
        pageName: 'PAGE_NAME_CART_ORDER_COMPLETE',
        eventType: 'EVENT_TYPE_VIEW',
        hashOrderId,
        pgType,
        pgAmount,
        orderAmount,
        couponAmount,
        pointAmount,
        nolPointAmount,
        packageDiscountAmount,
        fromCartYn,
        maxDiscountYn,
        trackCode,
        productOptions,
        rewardBenefit,
      })
    },
  },

  ButtonOrderDetail: {
    /**
     * 국내 주문완료 - 클릭 - 예약상세보기 - 버튼
     * 구 로그번호 : 없음(object = orderDetailBtn)
     *
     * txtpb
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/resources/clientlogs/order/misc/common.txtpb#L716}
     */
    click({}: CartOrderCompletePageLog.ButtonOrderDetail.Click = {}) {
      return KinesisTracker.click('CART_ORDER_COMPLETE', {
        inactive: false,
        clientEventId: 1563,
        pageName: 'PAGE_NAME_CART_ORDER_COMPLETE',
        object: 'orderDetail',
        objectType: 'OBJECT_TYPE_BUTTON',
        eventType: 'EVENT_TYPE_CLICK',
      })
    },
  },

  BenefitInfoTextType: {
    /**
     * 국내 주문완료 - 노출 - 혜택 - 텍스트
     *
     * txtpb
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/resources/clientlogs/order/misc/common.txtpb#L727}
     * CartOrderBenefitInfo
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/yanolja/clientlog/custom/order/misc.proto#L604}
     */
    impression({
      benefitType,
      benefitSubType,
    }: CartOrderCompletePageLog.BenefitInfoTextType.Impression) {
      return KinesisTracker.impression('CART_ORDER_COMPLETE', {
        inactive: false,
        clientEventId: 1564,
        pageName: 'PAGE_NAME_CART_ORDER_COMPLETE',
        object: 'benefitType',
        objectContainer: 'benefitInfo',
        objectType: 'OBJECT_TYPE_TEXT',
        eventType: 'EVENT_TYPE_IMPR',
        benefitType,
        benefitSubType,
      })
    },

    /**
     * 국내 주문완료 - 클릭 - 혜택 - 텍스트
     *
     * txtpb
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/resources/clientlogs/order/misc/common.txtpb#L740}
     * CartOrderBenefitInfo
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/yanolja/clientlog/custom/order/misc.proto#L604}
     */
    click({ benefitType, benefitSubType }: CartOrderCompletePageLog.BenefitInfoTextType.Click) {
      return KinesisTracker.click('CART_ORDER_COMPLETE', {
        inactive: false,
        clientEventId: 1565,
        pageName: 'PAGE_NAME_CART_ORDER_COMPLETE',
        object: 'benefitType',
        objectContainer: 'benefitInfo',
        objectType: 'OBJECT_TYPE_TEXT',
        eventType: 'EVENT_TYPE_CLICK',
        benefitType,
        benefitSubType,
      })
    },
  },

  ButtonHome: {
    /**
     * 국내 주문완료 - 클릭 - 홈으로가기 - 버튼
     * 구 로그번호 : 없음(object = homeBtn)
     *
     * txtpb
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/resources/clientlogs/order/misc/common.txtpb#L753}
     */
    click({}: CartOrderCompletePageLog.ButtonHome.Click = {}) {
      return KinesisTracker.click('CART_ORDER_COMPLETE', {
        inactive: false,
        clientEventId: 1566,
        pageName: 'PAGE_NAME_CART_ORDER_COMPLETE',
        object: 'home',
        objectType: 'OBJECT_TYPE_BUTTON',
        eventType: 'EVENT_TYPE_CLICK',
      })
    },
  },

  CardCrossPromotion: {
    /**
     * 국내 주문완료 - 노출 - 크로스프로모션(내부 크로스셀 및 타 서비스 크로스 프로모션 통칭) - 카드
     *
     * txtpb
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/resources/clientlogs/order/misc/common.txtpb#L764}
     * CartOrderCompleteCrossPromotion
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/yanolja/clientlog/custom/order/misc.proto#L799}
     */
    impression({
      subText,
      mainText,
      deepLinkUrl,
    }: CartOrderCompletePageLog.CardCrossPromotion.Impression) {
      return KinesisTracker.impression('CART_ORDER_COMPLETE', {
        inactive: false,
        clientEventId: 1567,
        pageName: 'PAGE_NAME_CART_ORDER_COMPLETE',
        object: 'crossPromotion',
        objectContainer: 'crossPromotion',
        objectType: 'OBJECT_TYPE_CARD',
        eventType: 'EVENT_TYPE_IMPR',
        subText,
        mainText,
        deepLinkUrl,
      })
    },
  },

  CrossPromotionButtonMainText: {
    /**
     * 국내 주문완료 - 클릭 - 크로스프로모션(내부 크로스셀 및 타 서비스 크로스 프로모션 통칭) - 버튼
     *
     * txtpb
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/resources/clientlogs/order/misc/common.txtpb#L777}
     * CartOrderCompleteCrossPromotion
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/yanolja/clientlog/custom/order/misc.proto#L799}
     */
    click({
      subText,
      mainText,
      deepLinkUrl,
    }: CartOrderCompletePageLog.CrossPromotionButtonMainText.Click) {
      return KinesisTracker.click('CART_ORDER_COMPLETE', {
        inactive: false,
        clientEventId: 1568,
        pageName: 'PAGE_NAME_CART_ORDER_COMPLETE',
        object: 'mainText',
        objectContainer: 'crossPromotion',
        objectType: 'OBJECT_TYPE_BUTTON',
        eventType: 'EVENT_TYPE_CLICK',
        subText,
        mainText,
        deepLinkUrl,
      })
    },
  },

  BenefitBannerId: {
    /**
     * 국내 주문완료 - 노출 - 베네핏배너
     * 구 로그번호 : 없음(object = $benefitBannerId)
     *
     * txtpb
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/resources/clientlogs/order/misc/common.txtpb#L790}
     * CartBannerImpr
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/yanolja/clientlog/custom/order/misc.proto#L521}
     */
    impression({
      benefitBannerId,
      benefitBannerTitle,
    }: CartOrderCompletePageLog.BenefitBannerId.Impression) {
      return KinesisTracker.impression('CART_ORDER_COMPLETE', {
        inactive: false,
        clientEventId: 1569,
        pageName: 'PAGE_NAME_CART_ORDER_COMPLETE',
        object: 'benefitBannerId',
        objectContainer: 'benefitBanner',
        objectType: 'OBJECT_TYPE_BANNER',
        eventType: 'EVENT_TYPE_IMPR',
        benefitBannerId,
        benefitBannerTitle,
      })
    },

    /**
     * 국내 주문완료 - 클릭 - 베네핏배너
     * 구 로그번호 : 없음(object = $benefitBannerId)
     *
     * txtpb
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/resources/clientlogs/order/misc/common.txtpb#L804}
     * CartBannerClick
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/yanolja/clientlog/custom/order/misc.proto#L529}
     */
    click({
      benefitBannerId,
      benefitBannerTitle,
      deepLinkUri,
    }: CartOrderCompletePageLog.BenefitBannerId.Click) {
      return KinesisTracker.click('CART_ORDER_COMPLETE', {
        inactive: false,
        clientEventId: 1570,
        pageName: 'PAGE_NAME_CART_ORDER_COMPLETE',
        object: 'benefitBannerId',
        objectContainer: 'benefitBanner',
        objectType: 'OBJECT_TYPE_BANNER',
        eventType: 'EVENT_TYPE_CLICK',
        benefitBannerId,
        benefitBannerTitle,
        deepLinkUri,
      })
    },
  },

  BannerType: {
    /**
     * 국내 주문완료 - 노출 - 혜택 정보 배너
     * 구 로그번호 : 없음(object = nolPromotion/yanoljaClassBanner)
     *
     * txtpb
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/resources/clientlogs/order/misc/common.txtpb#L817}
     * CartOrderCompleteBanner
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/yanolja/clientlog/custom/order/misc.proto#L806}
     */
    impression({
      bannerType,
      bannerSubType,
      mainText,
    }: CartOrderCompletePageLog.BannerType.Impression) {
      return KinesisTracker.impression('CART_ORDER_COMPLETE', {
        clientEventId: 1571,
        pageName: 'PAGE_NAME_CART_ORDER_COMPLETE',
        object: 'bannerType',
        objectType: 'OBJECT_TYPE_BANNER',
        eventType: 'EVENT_TYPE_IMPR',
        bannerType,
        bannerSubType,
        mainText,
      })
    },

    /**
     * 국내 주문완료 - 클릭 - 혜택 정보 배너
     * 구 로그번호 : 없음(object = nolPromotion/yanoljaClassBanner)
     *
     * txtpb
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/resources/clientlogs/order/misc/common.txtpb#L828}
     * CartOrderCompleteBanner
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/yanolja/clientlog/custom/order/misc.proto#L806}
     */
    click({ bannerType, bannerSubType, mainText }: CartOrderCompletePageLog.BannerType.Click) {
      return KinesisTracker.click('CART_ORDER_COMPLETE', {
        clientEventId: 1572,
        pageName: 'PAGE_NAME_CART_ORDER_COMPLETE',
        object: 'bannerType',
        objectType: 'OBJECT_TYPE_BANNER',
        eventType: 'EVENT_TYPE_CLICK',
        bannerType,
        bannerSubType,
        mainText,
      })
    },
  },

  ButtonClose: {
    /**
     * 국내 주문완료 - 클릭 - 닫기 - 버튼
     * ################################### 주문 리스트 (CART_ORDER_LIST) 로그 START ####################################
     *
     * txtpb
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/resources/clientlogs/order/misc/common.txtpb#L839}
     */
    click({}: CartOrderCompletePageLog.ButtonClose.Click = {}) {
      return KinesisTracker.click('CART_ORDER_COMPLETE', {
        clientEventId: 1900,
        pageName: 'PAGE_NAME_CART_ORDER_COMPLETE',
        object: 'close',
        objectType: 'OBJECT_TYPE_BUTTON',
        eventType: 'EVENT_TYPE_CLICK',
      })
    },
  },
}

/**
 * 자동생성된 로그 전송 타입
 */
export namespace CartOrderCompletePageLog {
  export namespace BannerYanoljaClass {
    /**
        * 신규 로그
100% 전환 이후 inactive 처리 예정
        */
    export interface Impression {}

    /**
     * 신규 로그
     */
    export interface Click {}
  }
  export namespace BannerTripPlan {
    /**
     */
    export interface Impression {
      hashOrderId: string
      /*참고 샘플 https://screen.yanolja.in/kHOTCGY9SYDItfUn*/
      tripId: string
      title: string
      subTitle: string
      /*신규 생성 일정 여부*/
      isNewTrip: boolean
    }

    /**
     */
    export interface Click {
      hashOrderId: string
      /*참고 샘플 https://screen.yanolja.in/kHOTCGY9SYDItfUn*/
      tripId: string
      title: string
      subTitle: string
      /*신규 생성 일정 여부*/
      isNewTrip: boolean
    }
  }
  export namespace FloatingButtonImprName {
    /**
     */
    export interface Impression {
      hashOrderId: string
      /*플로팅버튼 스크린샷 https://screen.yanolja.in/jNb0jebbUyNScYvJ*/
      imprName?: string
      /*클릭 문구*/
      clickName?: string
    }
  }
  export namespace FloatingButtonClickName {
    /**
     */
    export interface Click {
      hashOrderId: string
      /*플로팅버튼 스크린샷 https://screen.yanolja.in/jNb0jebbUyNScYvJ*/
      imprName?: string
      /*클릭 문구*/
      clickName?: string
    }
  }
  export namespace OrderCompleteView {
    /**
     */
    export interface View {
      /*1. 기본 결제 정보*/
      hashOrderId: string
      pgType: string
      pgAmount: string
      orderAmount: string
      couponAmount: string
      /*이전 야놀자포인트로 제외(놀포인트로 남음)*/
      pointAmount: string
      nolPointAmount: string
      packageDiscountAmount: string
      fromCartYn: string
      maxDiscountYn: string
      trackCode: string
      /*2. 상품 상세 정보 (복합 결제 수용)*/
      productOptions: OrderCompleteProductOptions
      /*3. 구매 적립 예정 놀포인트
예시 스샷 : https://screen.yanolja.in/nsbtCkGAe3QGRkSN
e.g. {memberClass:&#34;PLATINUM_CLASS&#34;, expectedRewardAmount:1500}*/
      rewardBenefit?: MemberRewardBenefit
    }
  }
  export namespace ButtonOrderDetail {
    /**
     * 구 로그번호 : 없음(object = orderDetailBtn)
     */
    export interface Click {}
  }
  export namespace BenefitInfoTextType {
    /**
     */
    export interface Impression {
      /*주문서 https://screen.yanolja.in/saOSE9SnSVT6yezL
예약완료 https://screen.yanolja.in/IT4oYygmkppAM7j1*/
      benefitType: string
      /*가입유도 배너 구분 ex) nolCoupon | nolFirstPay | nolPromotion*/
      benefitSubType: string
    }

    /**
     */
    export interface Click {
      /*주문서 https://screen.yanolja.in/saOSE9SnSVT6yezL
예약완료 https://screen.yanolja.in/IT4oYygmkppAM7j1*/
      benefitType: string
      /*가입유도 배너 구분 ex) nolCoupon | nolFirstPay | nolPromotion*/
      benefitSubType: string
    }
  }
  export namespace ButtonHome {
    /**
     * 구 로그번호 : 없음(object = homeBtn)
     */
    export interface Click {}
  }
  export namespace CardCrossPromotion {
    /**
     */
    export interface Impression {
      /*https://screen.yanolja.in/tHioVmnCcH2t0yra*/
      subText: string
      /*국내선 예약하고, 포인트까지 받아가자!*/
      mainText: string
      deepLinkUrl: string
    }
  }
  export namespace CrossPromotionButtonMainText {
    /**
     */
    export interface Click {
      /*https://screen.yanolja.in/tHioVmnCcH2t0yra*/
      subText: string
      /*국내선 예약하고, 포인트까지 받아가자!*/
      mainText: string
      deepLinkUrl: string
    }
  }
  export namespace BenefitBannerId {
    /**
     * 구 로그번호 : 없음(object = $benefitBannerId)
     */
    export interface Impression {
      /*장바구니 베네핏배너 노출 : https://screen.yanolja.in/X8lseN9gzsPa3xDQ
예약완료 베네핏배너 노출 : https://screen.yanolja.in/IaPM7qfcBnjMSefQ*/
      benefitBannerId: string
      /*배너타이틀*/
      benefitBannerTitle: string
    }

    /**
     * 구 로그번호 : 없음(object = $benefitBannerId)
     */
    export interface Click {
      /*장바구니 베네핏배너 클릭 : https://screen.yanolja.in/X8lseN9gzsPa3xDQ
예약완료 베네핏배너 클릭 : https://screen.yanolja.in/IaPM7qfcBnjMSefQ*/
      benefitBannerId: string
      /*배너타이틀*/
      benefitBannerTitle: string
      /*배너 진입 uri*/
      deepLinkUri: string
    }
  }
  export namespace BannerType {
    /**
     * 구 로그번호 : 없음(object = nolPromotion/yanoljaClassBanner)
     */
    export interface Impression {
      /*https://screen.yanolja.in/MUPWkpVc5aKvt4mM*/
      bannerType: string
      /*놀카드 가입유도 배너 구분 ex) nolCoupon | nolFirstPay | nolPromotion*/
      bannerSubType?: string
      mainText: string
    }

    /**
     * 구 로그번호 : 없음(object = nolPromotion/yanoljaClassBanner)
     */
    export interface Click {
      /*https://screen.yanolja.in/MUPWkpVc5aKvt4mM*/
      bannerType: string
      /*놀카드 가입유도 배너 구분 ex) nolCoupon | nolFirstPay | nolPromotion*/
      bannerSubType?: string
      mainText: string
    }
  }
  export namespace ButtonClose {
    /**
     * ################################### 주문 리스트 (CART_ORDER_LIST) 로그 START ####################################
     */
    export interface Click {}
  }
}

/**
 * PageName: CART_ORDER_LIST    */
export const CartOrderListPageLog = {
  OrderProdInfoButtonWriteReviewBtn: {
    /**
        * 국내 여행 예약 내역 페이지 - 후기 작성 버튼 노출
        * 신규 로그
스크린 : https://screen.yanolja.in/ZGIns0ZdwHIy9SMG  // https://screen.yanolja.in/P4OCxKa4nbz8uGKA
국내여행에는 국내숙소 및 레저 모두가 포함됨
        *
* txtpb
* @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/resources/clientlogs/order/misc/common.txtpb#L854}
        * CartOrderProdCommon
* @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/yanolja/clientlog/custom/order/misc.proto#L201}
        */
    impression({
      hashOrderId,
      hashCategoryOrderId,
      activeYn,
      productType,
      placeNo,
      roomTypeNo,
      ratePlanNo,
      leisureTicketNo,
      productGroupId,
      dealOptionNo,
    }: CartOrderListPageLog.OrderProdInfoButtonWriteReviewBtn.Impression) {
      return KinesisTracker.impression('CART_ORDER_LIST', {
        clientEventId: 111,
        pageName: 'PAGE_NAME_CART_ORDER_LIST',
        object: 'writeReviewBtn',
        objectContainer: 'orderProdInfo',
        objectType: 'OBJECT_TYPE_BUTTON',
        eventType: 'EVENT_TYPE_IMPR',
        hashOrderId,
        hashCategoryOrderId,
        activeYn,
        productType,
        placeNo,
        roomTypeNo,
        ratePlanNo,
        leisureTicketNo,
        productGroupId,
        dealOptionNo,
      })
    },

    /**
        * 국내 여행 예약 내역 페이지 - 후기 작성 버튼 클릭
        * 수정 로그
스크린 : https://screen.yanolja.in/ZGIns0ZdwHIy9SMG  // https://screen.yanolja.in/P4OCxKa4nbz8uGKA
국내여행에는 국내숙소 및 레저 모두가 포함됨
        *
* txtpb
* @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/resources/clientlogs/order/misc/common.txtpb#L869}
        * CartOrderProdCommon
* @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/yanolja/clientlog/custom/order/misc.proto#L201}
        */
    click({
      hashOrderId,
      hashCategoryOrderId,
      activeYn,
      productType,
      placeNo,
      roomTypeNo,
      ratePlanNo,
      leisureTicketNo,
      productGroupId,
      dealOptionNo,
    }: CartOrderListPageLog.OrderProdInfoButtonWriteReviewBtn.Click) {
      return KinesisTracker.click('CART_ORDER_LIST', {
        clientEventId: 112,
        pageName: 'PAGE_NAME_CART_ORDER_LIST',
        object: 'writeReviewBtn',
        objectContainer: 'orderProdInfo',
        objectType: 'OBJECT_TYPE_BUTTON',
        eventType: 'EVENT_TYPE_CLICK',
        hashOrderId,
        hashCategoryOrderId,
        activeYn,
        productType,
        placeNo,
        roomTypeNo,
        ratePlanNo,
        leisureTicketNo,
        productGroupId,
        dealOptionNo,
      })
    },
  },

  OrderProdInfoButtonQrBtn: {
    /**
        * 국내 여행 예약 내역 페이지 - 모바일 QR 보기 버튼 노출
        * 수정 로그 : 과거에는 버스,숙소,레저 다 다른 로그 였으나 아래 로그로 통합
스크린 : https://screen.yanolja.in/a1QbTGSKLjydj4Yx
        *
* txtpb
* @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/resources/clientlogs/order/misc/common.txtpb#L884}
        * CartOrderProdCommon
* @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/yanolja/clientlog/custom/order/misc.proto#L201}
        */
    impression({
      hashOrderId,
      hashCategoryOrderId,
      activeYn,
      productType,
      placeNo,
      roomTypeNo,
      ratePlanNo,
      leisureTicketNo,
      productGroupId,
      dealOptionNo,
    }: CartOrderListPageLog.OrderProdInfoButtonQrBtn.Impression) {
      return KinesisTracker.impression('CART_ORDER_LIST', {
        clientEventId: 427,
        pageName: 'PAGE_NAME_CART_ORDER_LIST',
        object: 'QRBtn',
        objectContainer: 'orderProdInfo',
        objectType: 'OBJECT_TYPE_BUTTON',
        eventType: 'EVENT_TYPE_IMPR',
        hashOrderId,
        hashCategoryOrderId,
        activeYn,
        productType,
        placeNo,
        roomTypeNo,
        ratePlanNo,
        leisureTicketNo,
        productGroupId,
        dealOptionNo,
      })
    },

    /**
        * 국내 여행 예약 내역 페이지 - 모바일 QR 보기 버튼 클릭
        * 수정 로그 : 과거에는 버스,숙소,레저 다 다른 로그 였으나 아래 로그로 통합
스크린 : https://screen.yanolja.in/a1QbTGSKLjydj4Yx
        *
* txtpb
* @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/resources/clientlogs/order/misc/common.txtpb#L898}
        * CartOrderProdCommon
* @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/yanolja/clientlog/custom/order/misc.proto#L201}
        */
    click({
      hashOrderId,
      hashCategoryOrderId,
      activeYn,
      productType,
      placeNo,
      roomTypeNo,
      ratePlanNo,
      leisureTicketNo,
      productGroupId,
      dealOptionNo,
    }: CartOrderListPageLog.OrderProdInfoButtonQrBtn.Click) {
      return KinesisTracker.click('CART_ORDER_LIST', {
        clientEventId: 428,
        pageName: 'PAGE_NAME_CART_ORDER_LIST',
        object: 'QRBtn',
        objectContainer: 'orderProdInfo',
        objectType: 'OBJECT_TYPE_BUTTON',
        eventType: 'EVENT_TYPE_CLICK',
        hashOrderId,
        hashCategoryOrderId,
        activeYn,
        productType,
        placeNo,
        roomTypeNo,
        ratePlanNo,
        leisureTicketNo,
        productGroupId,
        dealOptionNo,
      })
    },
  },

  ButtonSeeAllBtn: {
    /**
     * 국내 여행 예약 내역 페이지 - N개 상품 더보기 노출
     * 스크린 :https://screen.yanolja.in/6yp5xt9ReG39lI60
     *
     * txtpb
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/resources/clientlogs/order/misc/common.txtpb#L912}
     * CartOrderCommon
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/yanolja/clientlog/custom/order/misc.proto#L242}
     */
    impression({ hashOrderId, addOrderPageYn }: CartOrderListPageLog.ButtonSeeAllBtn.Impression) {
      return KinesisTracker.impression('CART_ORDER_LIST', {
        clientEventId: 429,
        pageName: 'PAGE_NAME_CART_ORDER_LIST',
        object: 'seeAllBtn',
        objectType: 'OBJECT_TYPE_BUTTON',
        eventType: 'EVENT_TYPE_IMPR',
        hashOrderId,
        addOrderPageYn,
      })
    },

    /**
     * 국내 여행 예약 내역 페이지 - N개 상품 더보기 클릭
     * 스크린 : https://screen.yanolja.in/6yp5xt9ReG39lI60
     *
     * txtpb
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/resources/clientlogs/order/misc/common.txtpb#L924}
     * CartOrderCommon
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/yanolja/clientlog/custom/order/misc.proto#L242}
     */
    click({ hashOrderId, addOrderPageYn }: CartOrderListPageLog.ButtonSeeAllBtn.Click) {
      return KinesisTracker.click('CART_ORDER_LIST', {
        clientEventId: 430,
        pageName: 'PAGE_NAME_CART_ORDER_LIST',
        object: 'seeAllBtn',
        objectType: 'OBJECT_TYPE_BUTTON',
        eventType: 'EVENT_TYPE_CLICK',
        hashOrderId,
        addOrderPageYn,
      })
    },
  },

  DmTalkButtonName: {
    /**
     * 국내 여행 예약 내역 페이지 - 노출 - 숙소1:1대화하기
     *
     * txtpb
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/resources/clientlogs/order/misc/common.txtpb#L936}
     * CartOrderDmTalkEvent
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/yanolja/clientlog/custom/order/misc.proto#L373}
     */
    impression({
      buttonName,
      placeNo,
      hashOrderId,
    }: CartOrderListPageLog.DmTalkButtonName.Impression) {
      return KinesisTracker.impression('CART_ORDER_LIST', {
        inactive: false,
        clientEventId: 663,
        pageName: 'PAGE_NAME_CART_ORDER_LIST',
        object: 'buttonName',
        objectContainer: 'dmTalk',
        objectType: 'OBJECT_TYPE_BUTTON',
        eventType: 'EVENT_TYPE_IMPR',
        buttonName,
        placeNo,
        hashOrderId,
      })
    },

    /**
     * 국내 여행 예약 내역 페이지 - 클릭 - 숙소1:1대화하기
     * ################################### 주문 상세 (CART_ORDER_DETAIL) 로그 START ####################################
     *
     * txtpb
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/resources/clientlogs/order/misc/common.txtpb#L949}
     * CartOrderDmTalkEvent
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/yanolja/clientlog/custom/order/misc.proto#L373}
     */
    click({ buttonName, placeNo, hashOrderId }: CartOrderListPageLog.DmTalkButtonName.Click) {
      return KinesisTracker.click('CART_ORDER_LIST', {
        inactive: false,
        clientEventId: 664,
        pageName: 'PAGE_NAME_CART_ORDER_LIST',
        object: 'buttonName',
        objectContainer: 'dmTalk',
        objectType: 'OBJECT_TYPE_BUTTON',
        eventType: 'EVENT_TYPE_CLICK',
        buttonName,
        placeNo,
        hashOrderId,
      })
    },
  },
}

/**
 * 자동생성된 로그 전송 타입
 */
export namespace CartOrderListPageLog {
  export namespace OrderProdInfoButtonWriteReviewBtn {
    /**
        * 신규 로그
스크린 : https://screen.yanolja.in/ZGIns0ZdwHIy9SMG  // https://screen.yanolja.in/P4OCxKa4nbz8uGKA
국내여행에는 국내숙소 및 레저 모두가 포함됨
        */
    export interface Impression {
      /*해시 주문 id - 통합주문 번호를 의미*/
      hashOrderId: string
      /*카테고리별 해시 주문 id*/
      hashCategoryOrderId: string
      /*후기작성 버튼이 확성화 되었다면, {&#39;active_yn&#39; : True} 비활성화 상태라면 {&#39;active_yn&#39; : False}
노출 로그에만 남겨주세요.*/
      activeYn?: boolean
      /*{product_type : &#39;accommodation_korea&#39;} ex, 국내숙소, 레저, 항공, 해외숙소 등 대분류 카테고리
국내숙소 : accommodation_korea , 레저 : leisure , 해외숙소 : accommodation_abroad*/
      productType: string
      /*국내숙소 상품일 경우 - 국내숙소 상품 No*/
      placeNo?: string
      /*국내숙소 상품일 경우 - 룸타입 No*/
      roomTypeNo?: string
      /*국내숙소 상품일 경우 - rateplanNo*/
      ratePlanNo?: string
      /*레저 상품일 경우 - leisureTicketNo*/
      leisureTicketNo?: string
      /*레저 상품일 경우 - product_group_id*/
      productGroupId?: string
      /*레저 상품일 경우 - deal_option_no*/
      dealOptionNo?: string
    }

    /**
        * 수정 로그
스크린 : https://screen.yanolja.in/ZGIns0ZdwHIy9SMG  // https://screen.yanolja.in/P4OCxKa4nbz8uGKA
국내여행에는 국내숙소 및 레저 모두가 포함됨
        */
    export interface Click {
      /*해시 주문 id - 통합주문 번호를 의미*/
      hashOrderId: string
      /*카테고리별 해시 주문 id*/
      hashCategoryOrderId: string
      /*후기작성 버튼이 확성화 되었다면, {&#39;active_yn&#39; : True} 비활성화 상태라면 {&#39;active_yn&#39; : False}
노출 로그에만 남겨주세요.*/
      activeYn?: boolean
      /*{product_type : &#39;accommodation_korea&#39;} ex, 국내숙소, 레저, 항공, 해외숙소 등 대분류 카테고리
국내숙소 : accommodation_korea , 레저 : leisure , 해외숙소 : accommodation_abroad*/
      productType: string
      /*국내숙소 상품일 경우 - 국내숙소 상품 No*/
      placeNo?: string
      /*국내숙소 상품일 경우 - 룸타입 No*/
      roomTypeNo?: string
      /*국내숙소 상품일 경우 - rateplanNo*/
      ratePlanNo?: string
      /*레저 상품일 경우 - leisureTicketNo*/
      leisureTicketNo?: string
      /*레저 상품일 경우 - product_group_id*/
      productGroupId?: string
      /*레저 상품일 경우 - deal_option_no*/
      dealOptionNo?: string
    }
  }
  export namespace OrderProdInfoButtonQrBtn {
    /**
        * 수정 로그 : 과거에는 버스,숙소,레저 다 다른 로그 였으나 아래 로그로 통합
스크린 : https://screen.yanolja.in/a1QbTGSKLjydj4Yx
        */
    export interface Impression {
      /*해시 주문 id - 통합주문 번호를 의미*/
      hashOrderId: string
      /*카테고리별 해시 주문 id*/
      hashCategoryOrderId: string
      /*후기작성 버튼이 확성화 되었다면, {&#39;active_yn&#39; : True} 비활성화 상태라면 {&#39;active_yn&#39; : False}
노출 로그에만 남겨주세요.*/
      activeYn?: boolean
      /*{product_type : &#39;accommodation_korea&#39;} ex, 국내숙소, 레저, 항공, 해외숙소 등 대분류 카테고리
국내숙소 : accommodation_korea , 레저 : leisure , 해외숙소 : accommodation_abroad*/
      productType: string
      /*국내숙소 상품일 경우 - 국내숙소 상품 No*/
      placeNo?: string
      /*국내숙소 상품일 경우 - 룸타입 No*/
      roomTypeNo?: string
      /*국내숙소 상품일 경우 - rateplanNo*/
      ratePlanNo?: string
      /*레저 상품일 경우 - leisureTicketNo*/
      leisureTicketNo?: string
      /*레저 상품일 경우 - product_group_id*/
      productGroupId?: string
      /*레저 상품일 경우 - deal_option_no*/
      dealOptionNo?: string
    }

    /**
        * 수정 로그 : 과거에는 버스,숙소,레저 다 다른 로그 였으나 아래 로그로 통합
스크린 : https://screen.yanolja.in/a1QbTGSKLjydj4Yx
        */
    export interface Click {
      /*해시 주문 id - 통합주문 번호를 의미*/
      hashOrderId: string
      /*카테고리별 해시 주문 id*/
      hashCategoryOrderId: string
      /*후기작성 버튼이 확성화 되었다면, {&#39;active_yn&#39; : True} 비활성화 상태라면 {&#39;active_yn&#39; : False}
노출 로그에만 남겨주세요.*/
      activeYn?: boolean
      /*{product_type : &#39;accommodation_korea&#39;} ex, 국내숙소, 레저, 항공, 해외숙소 등 대분류 카테고리
국내숙소 : accommodation_korea , 레저 : leisure , 해외숙소 : accommodation_abroad*/
      productType: string
      /*국내숙소 상품일 경우 - 국내숙소 상품 No*/
      placeNo?: string
      /*국내숙소 상품일 경우 - 룸타입 No*/
      roomTypeNo?: string
      /*국내숙소 상품일 경우 - rateplanNo*/
      ratePlanNo?: string
      /*레저 상품일 경우 - leisureTicketNo*/
      leisureTicketNo?: string
      /*레저 상품일 경우 - product_group_id*/
      productGroupId?: string
      /*레저 상품일 경우 - deal_option_no*/
      dealOptionNo?: string
    }
  }
  export namespace ButtonSeeAllBtn {
    /**
     * 스크린 :https://screen.yanolja.in/6yp5xt9ReG39lI60
     */
    export interface Impression {
      /*해시 주문 id - 통합주문 번호를 의미*/
      hashOrderId: string
      /*추가 주문 CartOrderPage 유무 &#39;Y&#39; 일 경우, 추가 주문 페이지를 의미함.*/
      addOrderPageYn: string
    }

    /**
     * 스크린 : https://screen.yanolja.in/6yp5xt9ReG39lI60
     */
    export interface Click {
      /*해시 주문 id - 통합주문 번호를 의미*/
      hashOrderId: string
      /*추가 주문 CartOrderPage 유무 &#39;Y&#39; 일 경우, 추가 주문 페이지를 의미함.*/
      addOrderPageYn: string
    }
  }
  export namespace DmTalkButtonName {
    /**
     */
    export interface Impression {
      /*노출/클릭한 버튼에 적혀 있는 내용*/
      buttonName: string
      /*노출/클릭한 버튼이 위치한 상품 id 값*/
      placeNo: string
      /*주문 정보*/
      hashOrderId: string
    }

    /**
     * ################################### 주문 상세 (CART_ORDER_DETAIL) 로그 START ####################################
     */
    export interface Click {
      /*노출/클릭한 버튼에 적혀 있는 내용*/
      buttonName: string
      /*노출/클릭한 버튼이 위치한 상품 id 값*/
      placeNo: string
      /*주문 정보*/
      hashOrderId: string
    }
  }
}

/**
 * PageName: CART_ORDER_DETAIL    */
export const CartOrderDetailPageLog = {
  OrderProdInfoButtonWriteReviewBtn: {
    /**
        * 국내 여행 예약 내역 상세 페이지 - 후기 작성 버튼 노출
        * 신규 로그
국내여행에는 국내숙소 및 레저 모두가 포함됨
        *
* txtpb
* @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/resources/clientlogs/order/misc/common.txtpb#L963}
        * CartOrderProdCommon
* @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/yanolja/clientlog/custom/order/misc.proto#L201}
        */
    impression({
      hashOrderId,
      hashCategoryOrderId,
      activeYn,
      productType,
      placeNo,
      roomTypeNo,
      ratePlanNo,
      leisureTicketNo,
      productGroupId,
      dealOptionNo,
    }: CartOrderDetailPageLog.OrderProdInfoButtonWriteReviewBtn.Impression) {
      return KinesisTracker.impression('CART_ORDER_DETAIL', {
        clientEventId: 113,
        pageName: 'PAGE_NAME_CART_ORDER_DETAIL',
        object: 'writeReviewBtn',
        objectContainer: 'orderProdInfo',
        objectType: 'OBJECT_TYPE_BUTTON',
        eventType: 'EVENT_TYPE_IMPR',
        hashOrderId,
        hashCategoryOrderId,
        activeYn,
        productType,
        placeNo,
        roomTypeNo,
        ratePlanNo,
        leisureTicketNo,
        productGroupId,
        dealOptionNo,
      })
    },

    /**
        * 국내 여행 예약 내역 상세 페이지 - 후기 작성 버튼 클릭
        * 수정 로그
국내여행에는 국내숙소 및 레저 모두가 포함됨
        *
* txtpb
* @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/resources/clientlogs/order/misc/common.txtpb#L977}
        * CartOrderProdCommon
* @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/yanolja/clientlog/custom/order/misc.proto#L201}
        */
    click({
      hashOrderId,
      hashCategoryOrderId,
      activeYn,
      productType,
      placeNo,
      roomTypeNo,
      ratePlanNo,
      leisureTicketNo,
      productGroupId,
      dealOptionNo,
    }: CartOrderDetailPageLog.OrderProdInfoButtonWriteReviewBtn.Click) {
      return KinesisTracker.click('CART_ORDER_DETAIL', {
        clientEventId: 114,
        pageName: 'PAGE_NAME_CART_ORDER_DETAIL',
        object: 'writeReviewBtn',
        objectContainer: 'orderProdInfo',
        objectType: 'OBJECT_TYPE_BUTTON',
        eventType: 'EVENT_TYPE_CLICK',
        hashOrderId,
        hashCategoryOrderId,
        activeYn,
        productType,
        placeNo,
        roomTypeNo,
        ratePlanNo,
        leisureTicketNo,
        productGroupId,
        dealOptionNo,
      })
    },
  },

  OrderProdInfoButtonQrBtn: {
    /**
        * 국내 여행 예약 내역 상세 페이지 - 모바일 QR 보기 버튼 노출
        * 수정 로그 : 과거에는 버스,숙소,레저 다 다른 로그 였으나 아래 로그로 통합
스크린 : https://screen.yanolja.in/a1QbTGSKLjydj4Yx
        *
* txtpb
* @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/resources/clientlogs/order/misc/common.txtpb#L991}
        * CartOrderProdCommon
* @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/yanolja/clientlog/custom/order/misc.proto#L201}
        */
    impression({
      hashOrderId,
      hashCategoryOrderId,
      activeYn,
      productType,
      placeNo,
      roomTypeNo,
      ratePlanNo,
      leisureTicketNo,
      productGroupId,
      dealOptionNo,
    }: CartOrderDetailPageLog.OrderProdInfoButtonQrBtn.Impression) {
      return KinesisTracker.impression('CART_ORDER_DETAIL', {
        clientEventId: 431,
        pageName: 'PAGE_NAME_CART_ORDER_DETAIL',
        object: 'QRBtn',
        objectContainer: 'orderProdInfo',
        objectType: 'OBJECT_TYPE_BUTTON',
        eventType: 'EVENT_TYPE_IMPR',
        hashOrderId,
        hashCategoryOrderId,
        activeYn,
        productType,
        placeNo,
        roomTypeNo,
        ratePlanNo,
        leisureTicketNo,
        productGroupId,
        dealOptionNo,
      })
    },

    /**
        * 국내 여행 예약 내역 상세 페이지 - 모바일 QR 보기 버튼 클릭
        * 수정 로그 : 과거에는 버스,숙소,레저 다 다른 로그 였으나 아래 로그로 통합
스크린 : https://screen.yanolja.in/a1QbTGSKLjydj4Yx
        *
* txtpb
* @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/resources/clientlogs/order/misc/common.txtpb#L1005}
        * CartOrderProdCommon
* @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/yanolja/clientlog/custom/order/misc.proto#L201}
        */
    click({
      hashOrderId,
      hashCategoryOrderId,
      activeYn,
      productType,
      placeNo,
      roomTypeNo,
      ratePlanNo,
      leisureTicketNo,
      productGroupId,
      dealOptionNo,
    }: CartOrderDetailPageLog.OrderProdInfoButtonQrBtn.Click) {
      return KinesisTracker.click('CART_ORDER_DETAIL', {
        clientEventId: 432,
        pageName: 'PAGE_NAME_CART_ORDER_DETAIL',
        object: 'QRBtn',
        objectContainer: 'orderProdInfo',
        objectType: 'OBJECT_TYPE_BUTTON',
        eventType: 'EVENT_TYPE_CLICK',
        hashOrderId,
        hashCategoryOrderId,
        activeYn,
        productType,
        placeNo,
        roomTypeNo,
        ratePlanNo,
        leisureTicketNo,
        productGroupId,
        dealOptionNo,
      })
    },
  },

  ButtonAddProdOrderBtn: {
    /**
     * 국내 여행 예약 내역 상세 페이지 - 추가 구매 상품 구매하기 버튼 노출
     * 스크린 : https://screen.yanolja.in/CCV81ugW6kR5QiEg
     *
     * txtpb
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/resources/clientlogs/order/misc/common.txtpb#L1019}
     * CartOrderCommon
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/yanolja/clientlog/custom/order/misc.proto#L242}
     */
    impression({
      hashOrderId,
      addOrderPageYn,
    }: CartOrderDetailPageLog.ButtonAddProdOrderBtn.Impression) {
      return KinesisTracker.impression('CART_ORDER_DETAIL', {
        clientEventId: 433,
        pageName: 'PAGE_NAME_CART_ORDER_DETAIL',
        object: 'addProdOrderBtn',
        objectType: 'OBJECT_TYPE_BUTTON',
        eventType: 'EVENT_TYPE_IMPR',
        hashOrderId,
        addOrderPageYn,
      })
    },

    /**
     * 국내 여행 예약 내역 상세 페이지 - 추가 구매 상품 구매하기 버튼 클릭
     * 스크린 : https://screen.yanolja.in/CCV81ugW6kR5QiEg
     *
     * txtpb
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/resources/clientlogs/order/misc/common.txtpb#L1031}
     * CartOrderCommon
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/yanolja/clientlog/custom/order/misc.proto#L242}
     */
    click({ hashOrderId, addOrderPageYn }: CartOrderDetailPageLog.ButtonAddProdOrderBtn.Click) {
      return KinesisTracker.click('CART_ORDER_DETAIL', {
        clientEventId: 434,
        pageName: 'PAGE_NAME_CART_ORDER_DETAIL',
        object: 'addProdOrderBtn',
        objectType: 'OBJECT_TYPE_BUTTON',
        eventType: 'EVENT_TYPE_CLICK',
        hashOrderId,
        addOrderPageYn,
      })
    },
  },

  ButtonSeeAllBtn: {
    /**
     * 국내 여행 예약 내역 상세 페이지 - N개 상품 더보기 노출
     * 스크린 :https://screen.yanolja.in/6yp5xt9ReG39lI60
     *
     * txtpb
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/resources/clientlogs/order/misc/common.txtpb#L1043}
     * CartOrderCommon
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/yanolja/clientlog/custom/order/misc.proto#L242}
     */
    impression({ hashOrderId, addOrderPageYn }: CartOrderDetailPageLog.ButtonSeeAllBtn.Impression) {
      return KinesisTracker.impression('CART_ORDER_DETAIL', {
        clientEventId: 435,
        pageName: 'PAGE_NAME_CART_ORDER_DETAIL',
        object: 'seeAllBtn',
        objectType: 'OBJECT_TYPE_BUTTON',
        eventType: 'EVENT_TYPE_IMPR',
        hashOrderId,
        addOrderPageYn,
      })
    },

    /**
     * 국내 여행 예약 내역 상세 페이지 - N개 상품 더보기 클릭
     * 스크린 : https://screen.yanolja.in/6yp5xt9ReG39lI60
     *
     * txtpb
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/resources/clientlogs/order/misc/common.txtpb#L1055}
     * CartOrderCommon
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/yanolja/clientlog/custom/order/misc.proto#L242}
     */
    click({ hashOrderId, addOrderPageYn }: CartOrderDetailPageLog.ButtonSeeAllBtn.Click) {
      return KinesisTracker.click('CART_ORDER_DETAIL', {
        clientEventId: 436,
        pageName: 'PAGE_NAME_CART_ORDER_DETAIL',
        object: 'seeAllBtn',
        objectType: 'OBJECT_TYPE_BUTTON',
        eventType: 'EVENT_TYPE_CLICK',
        hashOrderId,
        addOrderPageYn,
      })
    },
  },

  DmTalkButtonName: {
    /**
     * 국내 여행 예약 상세내역 페이지 - 노출 - 숙소1:1대화하기
     *
     * txtpb
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/resources/clientlogs/order/misc/common.txtpb#L1067}
     * CartOrderDmTalkEvent
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/yanolja/clientlog/custom/order/misc.proto#L373}
     */
    impression({
      buttonName,
      placeNo,
      hashOrderId,
    }: CartOrderDetailPageLog.DmTalkButtonName.Impression) {
      return KinesisTracker.impression('CART_ORDER_DETAIL', {
        inactive: false,
        clientEventId: 665,
        pageName: 'PAGE_NAME_CART_ORDER_DETAIL',
        object: 'buttonName',
        objectContainer: 'dmTalk',
        objectType: 'OBJECT_TYPE_BUTTON',
        eventType: 'EVENT_TYPE_IMPR',
        buttonName,
        placeNo,
        hashOrderId,
      })
    },

    /**
     * 국내 여행 예약 상세내역 페이지 - 클릭 - 숙소1:1대화하기
     * ################################### 주문 상세 (CART_ORDER_DETAIL) 로그 END ####################################
     *
     * txtpb
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/resources/clientlogs/order/misc/common.txtpb#L1080}
     * CartOrderDmTalkEvent
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/yanolja/clientlog/custom/order/misc.proto#L373}
     */
    click({ buttonName, placeNo, hashOrderId }: CartOrderDetailPageLog.DmTalkButtonName.Click) {
      return KinesisTracker.click('CART_ORDER_DETAIL', {
        inactive: false,
        clientEventId: 666,
        pageName: 'PAGE_NAME_CART_ORDER_DETAIL',
        object: 'buttonName',
        objectContainer: 'dmTalk',
        objectType: 'OBJECT_TYPE_BUTTON',
        eventType: 'EVENT_TYPE_CLICK',
        buttonName,
        placeNo,
        hashOrderId,
      })
    },
  },
}

/**
 * 자동생성된 로그 전송 타입
 */
export namespace CartOrderDetailPageLog {
  export namespace OrderProdInfoButtonWriteReviewBtn {
    /**
        * 신규 로그
국내여행에는 국내숙소 및 레저 모두가 포함됨
        */
    export interface Impression {
      /*해시 주문 id - 통합주문 번호를 의미*/
      hashOrderId: string
      /*카테고리별 해시 주문 id*/
      hashCategoryOrderId: string
      /*후기작성 버튼이 확성화 되었다면, {&#39;active_yn&#39; : True} 비활성화 상태라면 {&#39;active_yn&#39; : False}
노출 로그에만 남겨주세요.*/
      activeYn?: boolean
      /*{product_type : &#39;accommodation_korea&#39;} ex, 국내숙소, 레저, 항공, 해외숙소 등 대분류 카테고리
국내숙소 : accommodation_korea , 레저 : leisure , 해외숙소 : accommodation_abroad*/
      productType: string
      /*국내숙소 상품일 경우 - 국내숙소 상품 No*/
      placeNo?: string
      /*국내숙소 상품일 경우 - 룸타입 No*/
      roomTypeNo?: string
      /*국내숙소 상품일 경우 - rateplanNo*/
      ratePlanNo?: string
      /*레저 상품일 경우 - leisureTicketNo*/
      leisureTicketNo?: string
      /*레저 상품일 경우 - product_group_id*/
      productGroupId?: string
      /*레저 상품일 경우 - deal_option_no*/
      dealOptionNo?: string
    }

    /**
        * 수정 로그
국내여행에는 국내숙소 및 레저 모두가 포함됨
        */
    export interface Click {
      /*해시 주문 id - 통합주문 번호를 의미*/
      hashOrderId: string
      /*카테고리별 해시 주문 id*/
      hashCategoryOrderId: string
      /*후기작성 버튼이 확성화 되었다면, {&#39;active_yn&#39; : True} 비활성화 상태라면 {&#39;active_yn&#39; : False}
노출 로그에만 남겨주세요.*/
      activeYn?: boolean
      /*{product_type : &#39;accommodation_korea&#39;} ex, 국내숙소, 레저, 항공, 해외숙소 등 대분류 카테고리
국내숙소 : accommodation_korea , 레저 : leisure , 해외숙소 : accommodation_abroad*/
      productType: string
      /*국내숙소 상품일 경우 - 국내숙소 상품 No*/
      placeNo?: string
      /*국내숙소 상품일 경우 - 룸타입 No*/
      roomTypeNo?: string
      /*국내숙소 상품일 경우 - rateplanNo*/
      ratePlanNo?: string
      /*레저 상품일 경우 - leisureTicketNo*/
      leisureTicketNo?: string
      /*레저 상품일 경우 - product_group_id*/
      productGroupId?: string
      /*레저 상품일 경우 - deal_option_no*/
      dealOptionNo?: string
    }
  }
  export namespace OrderProdInfoButtonQrBtn {
    /**
        * 수정 로그 : 과거에는 버스,숙소,레저 다 다른 로그 였으나 아래 로그로 통합
스크린 : https://screen.yanolja.in/a1QbTGSKLjydj4Yx
        */
    export interface Impression {
      /*해시 주문 id - 통합주문 번호를 의미*/
      hashOrderId: string
      /*카테고리별 해시 주문 id*/
      hashCategoryOrderId: string
      /*후기작성 버튼이 확성화 되었다면, {&#39;active_yn&#39; : True} 비활성화 상태라면 {&#39;active_yn&#39; : False}
노출 로그에만 남겨주세요.*/
      activeYn?: boolean
      /*{product_type : &#39;accommodation_korea&#39;} ex, 국내숙소, 레저, 항공, 해외숙소 등 대분류 카테고리
국내숙소 : accommodation_korea , 레저 : leisure , 해외숙소 : accommodation_abroad*/
      productType: string
      /*국내숙소 상품일 경우 - 국내숙소 상품 No*/
      placeNo?: string
      /*국내숙소 상품일 경우 - 룸타입 No*/
      roomTypeNo?: string
      /*국내숙소 상품일 경우 - rateplanNo*/
      ratePlanNo?: string
      /*레저 상품일 경우 - leisureTicketNo*/
      leisureTicketNo?: string
      /*레저 상품일 경우 - product_group_id*/
      productGroupId?: string
      /*레저 상품일 경우 - deal_option_no*/
      dealOptionNo?: string
    }

    /**
        * 수정 로그 : 과거에는 버스,숙소,레저 다 다른 로그 였으나 아래 로그로 통합
스크린 : https://screen.yanolja.in/a1QbTGSKLjydj4Yx
        */
    export interface Click {
      /*해시 주문 id - 통합주문 번호를 의미*/
      hashOrderId: string
      /*카테고리별 해시 주문 id*/
      hashCategoryOrderId: string
      /*후기작성 버튼이 확성화 되었다면, {&#39;active_yn&#39; : True} 비활성화 상태라면 {&#39;active_yn&#39; : False}
노출 로그에만 남겨주세요.*/
      activeYn?: boolean
      /*{product_type : &#39;accommodation_korea&#39;} ex, 국내숙소, 레저, 항공, 해외숙소 등 대분류 카테고리
국내숙소 : accommodation_korea , 레저 : leisure , 해외숙소 : accommodation_abroad*/
      productType: string
      /*국내숙소 상품일 경우 - 국내숙소 상품 No*/
      placeNo?: string
      /*국내숙소 상품일 경우 - 룸타입 No*/
      roomTypeNo?: string
      /*국내숙소 상품일 경우 - rateplanNo*/
      ratePlanNo?: string
      /*레저 상품일 경우 - leisureTicketNo*/
      leisureTicketNo?: string
      /*레저 상품일 경우 - product_group_id*/
      productGroupId?: string
      /*레저 상품일 경우 - deal_option_no*/
      dealOptionNo?: string
    }
  }
  export namespace ButtonAddProdOrderBtn {
    /**
     * 스크린 : https://screen.yanolja.in/CCV81ugW6kR5QiEg
     */
    export interface Impression {
      /*해시 주문 id - 통합주문 번호를 의미*/
      hashOrderId: string
      /*추가 주문 CartOrderPage 유무 &#39;Y&#39; 일 경우, 추가 주문 페이지를 의미함.*/
      addOrderPageYn: string
    }

    /**
     * 스크린 : https://screen.yanolja.in/CCV81ugW6kR5QiEg
     */
    export interface Click {
      /*해시 주문 id - 통합주문 번호를 의미*/
      hashOrderId: string
      /*추가 주문 CartOrderPage 유무 &#39;Y&#39; 일 경우, 추가 주문 페이지를 의미함.*/
      addOrderPageYn: string
    }
  }
  export namespace ButtonSeeAllBtn {
    /**
     * 스크린 :https://screen.yanolja.in/6yp5xt9ReG39lI60
     */
    export interface Impression {
      /*해시 주문 id - 통합주문 번호를 의미*/
      hashOrderId: string
      /*추가 주문 CartOrderPage 유무 &#39;Y&#39; 일 경우, 추가 주문 페이지를 의미함.*/
      addOrderPageYn: string
    }

    /**
     * 스크린 : https://screen.yanolja.in/6yp5xt9ReG39lI60
     */
    export interface Click {
      /*해시 주문 id - 통합주문 번호를 의미*/
      hashOrderId: string
      /*추가 주문 CartOrderPage 유무 &#39;Y&#39; 일 경우, 추가 주문 페이지를 의미함.*/
      addOrderPageYn: string
    }
  }
  export namespace DmTalkButtonName {
    /**
     */
    export interface Impression {
      /*노출/클릭한 버튼에 적혀 있는 내용*/
      buttonName: string
      /*노출/클릭한 버튼이 위치한 상품 id 값*/
      placeNo: string
      /*주문 정보*/
      hashOrderId: string
    }

    /**
     * ################################### 주문 상세 (CART_ORDER_DETAIL) 로그 END ####################################
     */
    export interface Click {
      /*노출/클릭한 버튼에 적혀 있는 내용*/
      buttonName: string
      /*노출/클릭한 버튼이 위치한 상품 id 값*/
      placeNo: string
      /*주문 정보*/
      hashOrderId: string
    }
  }
}

/**
 * PageName: AML_VERIFY    */
export const AmlVerifyPageLog = {
  PageTitle: {
    /**
        * AML - CDD/EDD - 각종화면 진입
        * CDD 화면: https://screen.yanolja.in/gxCt85O8ah1zbZWO, https://screen.yanolja.in/loDbTSXCuv54rTd0
EDD 화면: https://screen.yanolja.in/YqBmwsGQoHEczygZ, https://screen.yanolja.in/WtephOkkChmWkXeU, https://screen.yanolja.in/d9ysocV8oitzYAZB
        *
* txtpb
* @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/resources/clientlogs/order/misc/common.txtpb#L1210}
        * AmlVerifyView
* @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/yanolja/clientlog/custom/order/misc.proto#L319}
        */
    view({ pageTitle }: AmlVerifyPageLog.PageTitle.View) {
      return KinesisTracker.view('AML_VERIFY', {
        inactive: false,
        clientEventId: 656,
        pageName: 'PAGE_NAME_AML_VERIFY',
        object: 'pageTitle',
        eventType: 'EVENT_TYPE_VIEW',
        pageTitle,
      })
    },
  },

  SectionNameButton: {
    /**
     * AML - CDD - 클릭 - 각종 섹션(바텀싯 포함) - 버튼
     *
     * txtpb
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/resources/clientlogs/order/misc/common.txtpb#L1223}
     * AmlVerifySectionClick
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/yanolja/clientlog/custom/order/misc.proto#L328}
     */
    click({ pageTitle, buttonName, sectionName }: AmlVerifyPageLog.SectionNameButton.Click) {
      return KinesisTracker.click('AML_VERIFY', {
        inactive: false,
        clientEventId: 657,
        pageName: 'PAGE_NAME_AML_VERIFY',
        object: 'buttonName',
        objectContainer: 'sectionName',
        objectType: 'OBJECT_TYPE_BUTTON',
        eventType: 'EVENT_TYPE_CLICK',
        pageTitle,
        buttonName,
        sectionName,
      })
    },
  },

  ButtonName: {
    /**
        * AML - CDD/EDD - 클릭 - 각종 버튼
        * CDD 화면: https://screen.yanolja.in/ieK0JqpIlBI1snAW, https://screen.yanolja.in/loDbTSXCuv54rTd0
EDD 화면: https://screen.yanolja.in/sRb8wnjtvumwIinZ, https://screen.yanolja.in/WtephOkkChmWkXeU, https://screen.yanolja.in/d9ysocV8oitzYAZB
        *
* txtpb
* @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/resources/clientlogs/order/misc/common.txtpb#L1236}
        * AmlVerifyClick
* @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/yanolja/clientlog/custom/order/misc.proto#L335}
        */
    click({ pageTitle, buttonName }: AmlVerifyPageLog.ButtonName.Click) {
      return KinesisTracker.click('AML_VERIFY', {
        inactive: false,
        clientEventId: 658,
        pageName: 'PAGE_NAME_AML_VERIFY',
        object: 'buttonName',
        objectType: 'OBJECT_TYPE_BUTTON',
        eventType: 'EVENT_TYPE_CLICK',
        pageTitle,
        buttonName,
      })
    },
  },

  SectionNamePopupTitle: {
    /**
        * AML - CDD/EDD - 노출 - 각종 팝업
        * CDD 화면: https://screen.yanolja.in/aqrift6QxRjUiRD3, https://screen.yanolja.in/OuDtvFAecO7cGxFX
EDD 화면: https://screen.yanolja.in/uya7ddIiVLHh3dEN
        *
* txtpb
* @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/resources/clientlogs/order/misc/common.txtpb#L1250}
        * AmlVerifyPopup
* @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/yanolja/clientlog/custom/order/misc.proto#L342}
        */
    impression({
      pageTitle,
      popupTitle,
      buttonName,
      sectionName,
    }: AmlVerifyPageLog.SectionNamePopupTitle.Impression) {
      return KinesisTracker.impression('AML_VERIFY', {
        inactive: false,
        clientEventId: 659,
        pageName: 'PAGE_NAME_AML_VERIFY',
        object: 'popupTitle',
        objectContainer: 'sectionName',
        objectType: 'OBJECT_TYPE_POPUP',
        eventType: 'EVENT_TYPE_IMPR',
        pageTitle,
        popupTitle,
        buttonName,
        sectionName,
      })
    },

    /**
        * AML - CDD 고객확인 - 클릭 - 각종 팝업
        * CDD 화면: https://screen.yanolja.in/aqrift6QxRjUiRD3, https://screen.yanolja.in/OuDtvFAecO7cGxFX
EDD 화면: https://screen.yanolja.in/uya7ddIiVLHh3dEN
버튼명이 모두 '확인'으로 popuptitle 로 구분
        *
* txtpb
* @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/resources/clientlogs/order/misc/common.txtpb#L1265}
        * AmlVerifyPopup
* @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/yanolja/clientlog/custom/order/misc.proto#L342}
        */
    click({
      pageTitle,
      popupTitle,
      buttonName,
      sectionName,
    }: AmlVerifyPageLog.SectionNamePopupTitle.Click) {
      return KinesisTracker.click('AML_VERIFY', {
        inactive: false,
        clientEventId: 660,
        pageName: 'PAGE_NAME_AML_VERIFY',
        object: 'popupTitle',
        objectContainer: 'sectionName',
        objectType: 'OBJECT_TYPE_POPUP',
        eventType: 'EVENT_TYPE_CLICK',
        pageTitle,
        popupTitle,
        buttonName,
        sectionName,
      })
    },
  },

  LabelAmlVerifyIdentification: {
    /**
        * AML - EDD 신분증 등록 시도
        * 로그시점 : EDD 페이지에서 정보 등록하기 버튼을 클릭하여 신분증 등록 API를 호출하는 시점
전금망을 통하지 않고도 자체적으로 서비스 내에서 신분증 등록 API 호출 현황을 쉽게 파악하기 위함
신분증 종류: 운전면허증, 주민등록증, 외국인 등록증
        *
* txtpb
* @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/resources/clientlogs/order/misc/common.txtpb#L1280}
        * AmlVerifyIdentification
* @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/yanolja/clientlog/custom/order/misc.proto#L351}
        */
    bg({
      pageTitle,
      amlVerifyIdentificationType,
    }: AmlVerifyPageLog.LabelAmlVerifyIdentification.Bg) {
      return KinesisTracker.bg('AML_VERIFY', {
        inactive: false,
        clientEventId: 907,
        pageName: 'PAGE_NAME_AML_VERIFY',
        object: 'amlVerifyIdentification',
        objectType: 'OBJECT_TYPE_LABEL',
        eventType: 'EVENT_TYPE_BG',
        pageTitle,
        amlVerifyIdentificationType,
      })
    },
  },
}

/**
 * 자동생성된 로그 전송 타입
 */
export namespace AmlVerifyPageLog {
  export namespace PageTitle {
    /**
        * CDD 화면: https://screen.yanolja.in/gxCt85O8ah1zbZWO, https://screen.yanolja.in/loDbTSXCuv54rTd0
EDD 화면: https://screen.yanolja.in/YqBmwsGQoHEczygZ, https://screen.yanolja.in/WtephOkkChmWkXeU, https://screen.yanolja.in/d9ysocV8oitzYAZB
        */
    export interface View {
      /*CDD : https://screen.yanolja.in/gxCt85O8ah1zbZWO
CDD_제출완료 : https://screen.yanolja.in/loDbTSXCuv54rTd0
EDD : https://screen.yanolja.in/YqBmwsGQoHEczygZ
EDD_신분증정보확인 : https://screen.yanolja.in/WtephOkkChmWkXeU
EDD_제출완료 : https://screen.yanolja.in/d9ysocV8oitzYAZB*/
      pageTitle: string
    }
  }
  export namespace SectionNameButton {
    /**
     */
    export interface Click {
      /*CDD : https://screen.yanolja.in/gxCt85O8ah1zbZWO*/
      pageTitle: string
      /*버튼에 적혀있는 내용*/
      buttonName: string
      /*섹션을 식별하는 이름*/
      sectionName: string
    }
  }
  export namespace ButtonName {
    /**
        * CDD 화면: https://screen.yanolja.in/ieK0JqpIlBI1snAW, https://screen.yanolja.in/loDbTSXCuv54rTd0
EDD 화면: https://screen.yanolja.in/sRb8wnjtvumwIinZ, https://screen.yanolja.in/WtephOkkChmWkXeU, https://screen.yanolja.in/d9ysocV8oitzYAZB
        */
    export interface Click {
      /*CDD : https://screen.yanolja.in/ieK0JqpIlBI1snAW, https://screen.yanolja.in/loDbTSXCuv54rTd0
EDD : https://screen.yanolja.in/sRb8wnjtvumwIinZ, https://screen.yanolja.in/WtephOkkChmWkXeU, https://screen.yanolja.in/d9ysocV8oitzYAZB*/
      pageTitle: string
      /*버튼에 적혀있는 내용*/
      buttonName: string
    }
  }
  export namespace SectionNamePopupTitle {
    /**
        * CDD 화면: https://screen.yanolja.in/aqrift6QxRjUiRD3, https://screen.yanolja.in/OuDtvFAecO7cGxFX
EDD 화면: https://screen.yanolja.in/uya7ddIiVLHh3dEN
        */
    export interface Impression {
      /*CDD : https://screen.yanolja.in/aqrift6QxRjUiRD3, https://screen.yanolja.in/OuDtvFAecO7cGxFX
EDD : https://screen.yanolja.in/uya7ddIiVLHh3dEN*/
      pageTitle: string
      /*팝업에 노출되는 메세지*/
      popupTitle: string
      /*버튼에 적혀있는 내용*/
      buttonName?: string
      /*섹션을 식별하는 이름*/
      sectionName: string
    }

    /**
        * CDD 화면: https://screen.yanolja.in/aqrift6QxRjUiRD3, https://screen.yanolja.in/OuDtvFAecO7cGxFX
EDD 화면: https://screen.yanolja.in/uya7ddIiVLHh3dEN
버튼명이 모두 '확인'으로 popuptitle 로 구분
        */
    export interface Click {
      /*CDD : https://screen.yanolja.in/aqrift6QxRjUiRD3, https://screen.yanolja.in/OuDtvFAecO7cGxFX
EDD : https://screen.yanolja.in/uya7ddIiVLHh3dEN*/
      pageTitle: string
      /*팝업에 노출되는 메세지*/
      popupTitle: string
      /*버튼에 적혀있는 내용*/
      buttonName?: string
      /*섹션을 식별하는 이름*/
      sectionName: string
    }
  }
  export namespace LabelAmlVerifyIdentification {
    /**
        * 로그시점 : EDD 페이지에서 정보 등록하기 버튼을 클릭하여 신분증 등록 API를 호출하는 시점
전금망을 통하지 않고도 자체적으로 서비스 내에서 신분증 등록 API 호출 현황을 쉽게 파악하기 위함
신분증 종류: 운전면허증, 주민등록증, 외국인 등록증
        */
    export interface Bg {
      /*EDD : https://screen.yanolja.in/WtephOkkChmWkXeU*/
      pageTitle: string
      /*신분증 타입*/
      amlVerifyIdentificationType: AmlVerifyIdentificationType
    }
  }
}

/**
 * PageName: CART_ORDER_PAYMENT    */
export const CartOrderPaymentPageLog = {
  PopupSectionName: {
    /**
     * 결제 - 결제 중 화면닫기 시 confirm 팝업 - 노출
     * 통합 주문(CartOrder) 이후, 일어나는 케이스
     *
     * txtpb
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/resources/clientlogs/order/misc/common.txtpb#L1376}
     * OrderSectionImpr
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/yanolja/clientlog/custom/misc.proto#L184}
     */
    impression({ sectionName, context }: CartOrderPaymentPageLog.PopupSectionName.Impression) {
      return KinesisTracker.impression('CART_ORDER_PAYMENT', {
        inactive: false,
        clientEventId: 741,
        pageName: 'PAGE_NAME_CART_ORDER_PAYMENT',
        object: 'sectionName',
        objectContainer: 'sectionName',
        objectType: 'OBJECT_TYPE_POPUP',
        eventType: 'EVENT_TYPE_IMPR',
        sectionName,
        context,
      })
    },
  },

  SectionNamePopupClick: {
    /**
     * 결제 - 결제 중 화면닫기 시 confirm 팝업 - 클릭
     * 통합 주문(CartOrder) 이후, 일어나는 케이스
     *
     * txtpb
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/resources/clientlogs/order/misc/common.txtpb#L1389}
     * OrderSectionClick
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/yanolja/clientlog/custom/misc.proto#L192}
     */
    click({
      sectionName,
      clickName,
      context,
    }: CartOrderPaymentPageLog.SectionNamePopupClick.Click) {
      return KinesisTracker.click('CART_ORDER_PAYMENT', {
        inactive: false,
        clientEventId: 742,
        pageName: 'PAGE_NAME_CART_ORDER_PAYMENT',
        object: 'clickName',
        objectContainer: 'sectionName',
        objectType: 'OBJECT_TYPE_POPUP',
        eventType: 'EVENT_TYPE_CLICK',
        sectionName,
        clickName,
        context,
      })
    },
  },
}

/**
 * 자동생성된 로그 전송 타입
 */
export namespace CartOrderPaymentPageLog {
  export namespace PopupSectionName {
    /**
     * 통합 주문(CartOrder) 이후, 일어나는 케이스
     */
    export interface Impression {
      /*주문 - 3분 이내 동일결제금액 confirm 팝업 https://screen.yanolja.in/3nV5wHf3RhlOnnUe
결제 - 결제 중 화면닫기 시 confirm 팝업 https://screen.yanolja.in/LPJBP8H8CB1iOLZ5
놀머니 이어서 등록하기 바텀시트 https://screen.yanolja.in/zI1RuPgwnRnlOklT*/
      sectionName: string
      /*서비스/디바이스 구분 정보 (놀 결제 화면에서 발생 시에만 설정)*/
      context?: PaymentLogContext
    }
  }
  export namespace SectionNamePopupClick {
    /**
     * 통합 주문(CartOrder) 이후, 일어나는 케이스
     */
    export interface Click {
      /*주문 - 3분 이내 동일결제금액 confirm 팝업 https://screen.yanolja.in/3nV5wHf3RhlOnnUe
결제 - 결제 중 화면닫기 시 confirm 팝업 https://screen.yanolja.in/LPJBP8H8CB1iOLZ5
놀머니 이어서 등록하기 바텀시트 https://screen.yanolja.in/zI1RuPgwnRnlOklT*/
      sectionName: string
      clickName: string
      /*서비스/디바이스 구분 정보 (놀 결제 화면에서 발생 시에만 설정)*/
      context?: PaymentLogContext
    }
  }
}

/**
 * PageName: CART_ORDER_CANCEL    */
export const CartOrderCancelPageLog = {
  PopupCancelFailed: {
    /**
        * 주문 취소 - 취소 요청 실패 팝업 노출
        * 스크린 : https://screen.yanolja.in/NRItxXaxxLodJvMX
################################### 장바구니 로그
        *
* txtpb
* @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/resources/clientlogs/order/misc/common.txtpb#L1432}
        * CartOrderPopup
* @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/yanolja/clientlog/custom/order/misc.proto#L254}
        */
    impression({
      hashOrderId,
      popupTitle,
      addOrderPageYn,
    }: CartOrderCancelPageLog.PopupCancelFailed.Impression) {
      return KinesisTracker.impression('CART_ORDER_CANCEL', {
        clientEventId: 437,
        pageName: 'PAGE_NAME_CART_ORDER_CANCEL',
        object: 'cancelFailedPopup',
        objectType: 'OBJECT_TYPE_POPUP',
        eventType: 'EVENT_TYPE_IMPR',
        hashOrderId,
        popupTitle,
        addOrderPageYn,
      })
    },
  },
}

/**
 * 자동생성된 로그 전송 타입
 */
export namespace CartOrderCancelPageLog {
  export namespace PopupCancelFailed {
    /**
        * 스크린 : https://screen.yanolja.in/NRItxXaxxLodJvMX
################################### 장바구니 로그
        */
    export interface Impression {
      /*해시 주문 id - 통합주문 번호를 의미*/
      hashOrderId: string
      /*팝업타이틀 ex) 입장권 수량에 맞게 화담채와 모노레일도 취소해 주세요.*/
      popupTitle: string
      /*추가 주문 CartOrderPage 유무 &#39;Y&#39; 일 경우, 추가 주문 페이지를 의미함.*/
      addOrderPageYn: string
    }
  }
}

/**
 * PageName: CART    */
export const CartPageLog = {
  CartViewInfo: {
    /**
     * 장바구니 - 진입
     *
     * txtpb
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/resources/clientlogs/order/misc/common.txtpb#L1451}
     * CartViewInfo
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/yanolja/clientlog/custom/order/misc.proto#L486}
     */
    view({ productOptions }: CartPageLog.CartViewInfo.View) {
      return KinesisTracker.view('CART', {
        inactive: false,
        clientEventId: 924,
        pageName: 'PAGE_NAME_CART',
        eventType: 'EVENT_TYPE_VIEW',
        productOptions,
      })
    },
  },

  ProductIdLinkCartOption: {
    /**
     * 장바구니 - 클릭 - 상품정보 - 링크
     *
     * txtpb
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/resources/clientlogs/order/misc/common.txtpb#L1461}
     * CartClickInfo
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/yanolja/clientlog/custom/order/misc.proto#L490}
     */
    click({ productOption }: CartPageLog.ProductIdLinkCartOption.Click) {
      return KinesisTracker.click('CART', {
        inactive: false,
        clientEventId: 925,
        pageName: 'PAGE_NAME_CART',
        object: 'cartProductOption',
        objectContainer: 'productId',
        objectType: 'OBJECT_TYPE_LINK',
        eventType: 'EVENT_TYPE_CLICK',
        productOption,
      })
    },
  },

  ButtonOrder: {
    /**
     * 장바구니 - 클릭 - 구매하기 - 버튼
     *
     * txtpb
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/resources/clientlogs/order/misc/common.txtpb#L1476}
     * CartOrderClickInfo
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/yanolja/clientlog/custom/order/misc.proto#L495}
     */
    click({ productOptions, packageDiscountAmount, trackCode }: CartPageLog.ButtonOrder.Click) {
      return KinesisTracker.click('CART', {
        inactive: false,
        clientEventId: 926,
        pageName: 'PAGE_NAME_CART',
        object: 'order',
        objectType: 'OBJECT_TYPE_BUTTON',
        eventType: 'EVENT_TYPE_CLICK',
        productOptions,
        packageDiscountAmount,
        trackCode,
      })
    },
  },

  ButtonClickName: {
    /**
     * 장바구니 - 클릭 - 각종 버튼 (로그인/예약불가삭제 등)
     * 예약불가삭제 클릭 https://screen.yanolja.in/Qjk8SYYCf0XPY3mW
     *
     * txtpb
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/resources/clientlogs/order/misc/common.txtpb#L1489}
     * CartClick
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/yanolja/clientlog/custom/order/misc.proto#L490}
     */
    click({ clickName }: CartPageLog.ButtonClickName.Click) {
      return KinesisTracker.click('CART', {
        inactive: false,
        clientEventId: 927,
        pageName: 'PAGE_NAME_CART',
        object: 'clickName',
        objectType: 'OBJECT_TYPE_BUTTON',
        eventType: 'EVENT_TYPE_CLICK',
        clickName,
      })
    },
  },

  ChangeUseTimeBottomSheetButton: {
    /**
     * 장바구니 - 클릭 - 대실시간 변경 - 바텀시트
     *
     * txtpb
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/resources/clientlogs/order/misc/common.txtpb#L1503}
     * CartChangeUseTime
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/yanolja/clientlog/custom/order/misc.proto#L516}
     */
    click({ changeUseTime }: CartPageLog.ChangeUseTimeBottomSheetButton.Click) {
      return KinesisTracker.click('CART', {
        inactive: false,
        clientEventId: 928,
        pageName: 'PAGE_NAME_CART',
        object: 'changeUseTime',
        objectContainer: 'changeUseTimeBottomSheet',
        objectType: 'OBJECT_TYPE_BUTTON',
        eventType: 'EVENT_TYPE_CLICK',
        changeUseTime,
      })
    },
  },

  PopupSectionName: {
    /**
     * 장바구니 - 노출 - 각종 팝업 (대실 시간 변경, 골드클래스 등급하락 구매불가 등)
     *
     * txtpb
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/resources/clientlogs/order/misc/common.txtpb#L1518}
     * CartPopupImpr
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/yanolja/clientlog/custom/order/misc.proto#L543}
     */
    impression({ sectionName }: CartPageLog.PopupSectionName.Impression) {
      return KinesisTracker.impression('CART', {
        inactive: false,
        clientEventId: 929,
        pageName: 'PAGE_NAME_CART',
        object: 'sectionName',
        objectContainer: 'sectionName',
        objectType: 'OBJECT_TYPE_POPUP',
        eventType: 'EVENT_TYPE_IMPR',
        sectionName,
      })
    },
  },

  SectionNameButtonClick: {
    /**
     * 장바구니 - 클릭 - 각종 팝업 (대실 시간 변경, 골드클래스 등급하락 구매불가 등)
     *
     * txtpb
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/resources/clientlogs/order/misc/common.txtpb#L1532}
     * CartPopupClick
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/yanolja/clientlog/custom/order/misc.proto#L548}
     */
    click({ sectionName, clickName }: CartPageLog.SectionNameButtonClick.Click) {
      return KinesisTracker.click('CART', {
        inactive: false,
        clientEventId: 930,
        pageName: 'PAGE_NAME_CART',
        object: 'clickName',
        objectContainer: 'sectionName',
        objectType: 'OBJECT_TYPE_BUTTON',
        eventType: 'EVENT_TYPE_CLICK',
        sectionName,
        clickName,
      })
    },
  },

  BenefitBannerId: {
    /**
     * 장바구니 - 노출 - 베네핏배너
     *
     * txtpb
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/resources/clientlogs/order/misc/common.txtpb#L1546}
     * CartBannerImpr
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/yanolja/clientlog/custom/order/misc.proto#L521}
     */
    impression({ benefitBannerId, benefitBannerTitle }: CartPageLog.BenefitBannerId.Impression) {
      return KinesisTracker.impression('CART', {
        inactive: false,
        clientEventId: 931,
        pageName: 'PAGE_NAME_CART',
        object: 'benefitBannerId',
        objectContainer: 'benefitBanner',
        objectType: 'OBJECT_TYPE_BANNER',
        eventType: 'EVENT_TYPE_IMPR',
        benefitBannerId,
        benefitBannerTitle,
      })
    },

    /**
     * 장바구니 - 클릭 - 베네핏배너
     *
     * txtpb
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/resources/clientlogs/order/misc/common.txtpb#L1560}
     * CartBannerClick
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/yanolja/clientlog/custom/order/misc.proto#L529}
     */
    click({ benefitBannerId, benefitBannerTitle, deepLinkUri }: CartPageLog.BenefitBannerId.Click) {
      return KinesisTracker.click('CART', {
        inactive: false,
        clientEventId: 932,
        pageName: 'PAGE_NAME_CART',
        object: 'benefitBannerId',
        objectContainer: 'benefitBanner',
        objectType: 'OBJECT_TYPE_BANNER',
        eventType: 'EVENT_TYPE_CLICK',
        benefitBannerId,
        benefitBannerTitle,
        deepLinkUri,
      })
    },
  },

  PriceChangeDownInfoBottomSheet: {
    /**
     * 장바구니 - 노출 - 골드클래스 가격인하 - 바텀시트
     *
     * txtpb
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/resources/clientlogs/order/misc/common.txtpb#L1574}
     * PriceChangeDownInfo
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/yanolja/clientlog/custom/order/misc.proto#L554}
     */
    impression({ priceChangedItems }: CartPageLog.PriceChangeDownInfoBottomSheet.Impression) {
      return KinesisTracker.impression('CART', {
        inactive: false,
        clientEventId: 933,
        pageName: 'PAGE_NAME_CART',
        object: 'priceChangeDownInfo',
        objectContainer: 'priceChangeDownInfoBottomSheet',
        objectType: 'OBJECT_TYPE_BOTTOM_SHEET',
        eventType: 'EVENT_TYPE_IMPR',
        priceChangedItems,
      })
    },
  },

  PriceChangeDownInfoBottomSheetButtonOrder: {
    /**
     * 장바구니 - 클릭 - 골드클래스 가격인하 - 바텀시트
     *
     * txtpb
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/resources/clientlogs/order/misc/common.txtpb#L1588}
     * PriceChangeDownInfo
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/yanolja/clientlog/custom/order/misc.proto#L554}
     */
    click({ priceChangedItems }: CartPageLog.PriceChangeDownInfoBottomSheetButtonOrder.Click) {
      return KinesisTracker.click('CART', {
        inactive: false,
        clientEventId: 934,
        pageName: 'PAGE_NAME_CART',
        object: 'order',
        objectContainer: 'priceChangeDownInfoBottomSheet',
        objectType: 'OBJECT_TYPE_BUTTON',
        eventType: 'EVENT_TYPE_CLICK',
        priceChangedItems,
      })
    },
  },
}

/**
 * 자동생성된 로그 전송 타입
 */
export namespace CartPageLog {
  export namespace CartViewInfo {
    /**
     */
    export interface View {
      /*상품 정보*/
      productOptions?: CartProductOptions[]
    }
  }
  export namespace ProductIdLinkCartOption {
    /**
     */
    export interface Click {
      /*상품정보클릭 : https://screen.yanolja.in/2FPkEeaI7fskrVGw*/
      productOption: CartProductOptions
    }
  }
  export namespace ButtonOrder {
    /**
     */
    export interface Click {
      /*구매하기 버튼 클릭 : https://screen.yanolja.in/fVUN1xAllPlaek9Y*/
      productOptions?: CartProductOptions[]
      packageDiscountAmount: number
      /*유입채널 eg.mkt_googlehotels*/
      trackCode: string
    }
  }
  export namespace ButtonClickName {
    /**
     * 예약불가삭제 클릭 https://screen.yanolja.in/Qjk8SYYCf0XPY3mW
     */
    export interface Click {
      /*예약불가삭제 클릭 : https://screen.yanolja.in/Qjk8SYYCf0XPY3mW
로그인 클릭 : https://screen.yanolja.in/lKXMMgxOXYGbg925*/
      clickName: CartClickType
    }
  }
  export namespace ChangeUseTimeBottomSheetButton {
    /**
     */
    export interface Click {
      /*대실 시간 변경 클릭 : https://screen.yanolja.in/02xv0Nb08zCgcceS*/
      changeUseTime: string
    }
  }
  export namespace PopupSectionName {
    /**
     */
    export interface Impression {
      /*대실시간 변경 : &#34;https://screen.yanolja.in/0h3aMjgJsD3zr81I&#34;*/
      sectionName: CartPopupType
    }
  }
  export namespace SectionNameButtonClick {
    /**
     */
    export interface Click {
      /*대실시간 변경 : &#34;https://screen.yanolja.in/0h3aMjgJsD3zr81I&#34;*/
      sectionName: CartPopupType
      /*클릭 버튼에 적혀있는 내용*/
      clickName: string
    }
  }
  export namespace BenefitBannerId {
    /**
     */
    export interface Impression {
      /*장바구니 베네핏배너 노출 : https://screen.yanolja.in/X8lseN9gzsPa3xDQ
예약완료 베네핏배너 노출 : https://screen.yanolja.in/IaPM7qfcBnjMSefQ*/
      benefitBannerId: string
      /*배너타이틀*/
      benefitBannerTitle: string
    }

    /**
     */
    export interface Click {
      /*장바구니 베네핏배너 클릭 : https://screen.yanolja.in/X8lseN9gzsPa3xDQ
예약완료 베네핏배너 클릭 : https://screen.yanolja.in/IaPM7qfcBnjMSefQ*/
      benefitBannerId: string
      /*배너타이틀*/
      benefitBannerTitle: string
      /*배너 진입 uri*/
      deepLinkUri: string
    }
  }
  export namespace PriceChangeDownInfoBottomSheet {
    /**
     */
    export interface Impression {
      /*골드클래스가격인하 : &#34;https://screen.yanolja.in/rWsCcFPoUBjGsd6t&#34;*/
      priceChangedItems: string
    }
  }
  export namespace PriceChangeDownInfoBottomSheetButtonOrder {
    /**
     */
    export interface Click {
      /*골드클래스가격인하 : &#34;https://screen.yanolja.in/rWsCcFPoUBjGsd6t&#34;*/
      priceChangedItems: string
    }
  }
}
